import React, { useEffect } from "react";
import qt from "@qt-base/jssdk";
import wxShare from "@qt-wx/share";
import qtWebLog from "@qt-mobile/web-log";
import "@qt-web/rem-standard";
import "@qt-web/css-common";
import { useRef, useState } from "react";
import { useState as useState__3, Fragment } from "react";
import Modal from "@qt-react/modal";
import "@qt-react/modal/dist/index.css";
import { useState as useState__5 } from "react";
import "video.js/dist/video-js.css";
import { useState as useState__6 } from "react";
import { useState as useState__7, useEffect as useEffect__7 } from "react";
import axios from "axios";
import Toast from "@qt-react/toast";
import "@qt-react/toast/dist/index.css";
import { useState as useState__16 } from "react";
import { useState as useState__17 } from "react";
import { useState as useState__18, useEffect as useEffect__18 } from "react";
import { useState as useState__24 } from "react";
import { useState as useState__25, useEffect as useEffect__25 } from "react";
import { useEffect as useEffect__32, useState as useState__32 } from "react";
import "swiper/css/swiper.min.css";
import { useState as useState__36 } from "react";
import { useState as useState__39 } from "react";
import { useState as useState__42 } from "react";
import "@qt-mobile/web-linkedme";
import get from "lodash/get";
import { useState as useState__52 } from "react";
import { useState as useState__53, useEffect as useEffect__53 } from "react";
import { useState as useState__61 } from "react";
import { useState as useState__64 } from "react";
import { useState as useState__65 } from "react";
import { useState as useState__66, useEffect as useEffect__66 } from "react";
import { useState as useState__72 } from "react";
import { useState as useState__73, useEffect as useEffect__73 } from "react";
import { useState as useState__78 } from "react";
import { Component } from "react";
import Index from "@qt-member/draw";
import "@qt-member/draw/mdist/index.css";
import jscookie from "js-cookie";
import LotteryGrid from "@lib-common/lottery-grid";
import { useState as useState__82, useRef as useRef__82, useMemo } from "react";
import { useState as useState__83, useEffect as useEffect__83 } from "react";
import { useState as useState__84, useEffect as useEffect__84 } from "react";
import { useState as useState__85, useEffect as useEffect__85 } from "react";
import { useState as useState__86, useEffect as useEffect__86 } from "react";
import { useState as useState__87, useEffect as useEffect__87 } from "react";
import { useState as useState__90 } from "react";
import { useState as useState__95 } from "react";
import { useState as useState__96, useEffect as useEffect__96 } from "react";
import { useState as useState__97 } from "react";
import { useEffect as useEffect__98 } from "react";
import { useState as useState__100 } from "react";
import { useEffect as useEffect__101 } from "react";
import { useState as useState__103 } from "react";
import throttle from "lodash/throttle";
window.__BUILDER_PAGE_ID = '5e9075ab41863131e7961258';
qtWebLog.push('_setAccount', 'MobileSite');

const formatTime = time => {
  const newTime = new Date(time.replace(/-/g, '/'));
  return newTime;
};

const isExpire = endTime => {
  const currentTime = new Date();

  if (endTime) {
    const newEndTime = formatTime(endTime);

    if (currentTime > newEndTime) {
      return true;
    }
  }

  return false;
};

const isNotStart = startTime => {
  const currentTime = new Date();

  if (startTime) {
    const newStartTime = formatTime(startTime);

    if (currentTime < newStartTime) {
      return true;
    }
  }

  return false;
};

const getDisplayBlock = (startTime, endTime) => {
  let display = "block";

  if (endTime && isExpire(endTime) || startTime && isNotStart(startTime)) {
    display = 'none';
  }

  return display;
};

const getShareLink = () => {
  const url = window.location.href;
  return url;
};

const getHeight = () => {
  const winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  return winHeight;
};

const ContainerRender = props => {
  const {
    startTime,
    endTime,
    endTitle,
    beforeTitle,
    bgc,
    themeColor,
    bgimg,
    style,
    margin,
    padding
  } = props.containerProps;
  const children = props.children;
  const isExpireShow = isExpire(endTime);
  const tip = endTime && isExpireShow ? endTitle ? endTitle : '页面已过期~' : beforeTitle ? beforeTitle : '活动还未开始，敬请期待~';
  const display = getDisplayBlock(startTime, endTime);
  const currentStyle = {
    background: bgc,
    color: themeColor,
    minHeight: getHeight(),
    backgroundImage: `url(${bgimg})`,
    backgroundRepeat: 'repeat',
    margin,
    padding
  };
  const useStyle = Object.assign(currentStyle, style);
  return display === 'block' ? <div className="scroll-y" style={useStyle}>{children}</div> : <div style={{
    minHeight: getHeight(),
    display: 'flex',
    alignItems: 'center'
  }}>
        <div style={{
      textAlign: 'center',
      transform: 'translateY(-1rem)',
      width: '100%'
    }}>
            <div style={{
        width: '6rem',
        margin: '0 auto'
      }}><img style={{
          width: '100%'
        }} alt={'logo'} src={'https://pic.qingting.fm/activity/123/qtlogo.png'} /></div>
            <div style={{
        fontSize: '0.85rem',
        color: '#333',
        width: '100%',
        textAlign: 'center',
        paddingTop: '0.5rem'
      }}>{tip}</div>
        </div>
    </div>;
};

const getStyle = imgInfo => {
  let top = imgInfo.marginTop,
      bottom = imgInfo.marginBottom,
      left = imgInfo.marginLeft,
      right = imgInfo.marginRight,
      unit = imgInfo.unit;

  if (unit !== 'px') {
    top = top + unit;
    right = right + unit;
    bottom = bottom + unit;
    left = left + unit;
  }

  const width = imgInfo.containerWidth;
  const height = imgInfo.containerHeight;
  let imgWrapStyle = {
    width,
    display: imgInfo.display,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    height,
    fontSize: '14px',
    borderRadius: imgInfo.borderRadius,
    marginTop: top,
    marginBottom: bottom,
    marginLeft: left,
    marginRight: right,
    zIndex: imgInfo.zIndex,
    position: imgInfo.position
  };
  let innerStyle = {
    width: imgInfo.gifWidth,
    display: imgInfo.display,
    justifyContent: 'center',
    alignItems: 'center',
    height: imgInfo.gifHeight,
    fontSize: '14px',
    borderRadius: imgInfo.borderRadius,
    position: "relative"
  };

  if (imgInfo.position === 'fixed' || imgInfo.position === 'absolute') {
    imgWrapStyle = {
      width,
      display: imgInfo.display,
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      height,
      fontSize: '14px',
      borderRadius: imgInfo.borderRadius,
      top,
      bottom,
      left,
      right,
      zIndex: imgInfo.zIndex,
      position: imgInfo.position
    };
  }

  const imgGifStyle = {
    width: imgInfo.gifWidth,
    height: imgInfo.gifHeight,
    display: 'block',
    top: '0',
    left: "0",
    opacity: '1',
    position: 'absolute'
  };
  const LoadingImgStyle = {
    width: imgInfo.loadingWidth,
    height: imgInfo.loadingHeight,
    display: 'block',
    top: '0',
    left: "0",
    opacity: '0'
  };
  return {
    imgWrapStyle,
    imgGifStyle,
    LoadingImgStyle,
    innerStyle
  };
};

const RenderGif = ({
  imgInfo: imgInfo,
  children: children
}) => {
  const ref = useRef(null);
  const style = getStyle(imgInfo);
  const [load, setLoad] = useState(1);
  let {
    LoadingImgStyle,
    imgGifStyle,
    innerStyle,
    imgWrapStyle
  } = style;
  useEffect(() => {
    let imgDom = ref.current;

    imgDom.onload = () => {
      setLoad(2);
    };
  }, []);

  if (load + '' === '2') {
    imgGifStyle.opacity = 1;
    imgGifStyle.position = "relative";
  }

  return <div style={imgWrapStyle}>
        <div style={innerStyle}>
            <img style={imgGifStyle} ref={ref} alt={imgInfo.imgAlt} src={imgInfo.gifImg} />
            {load + '' === '1' ? <img style={LoadingImgStyle} alt={imgInfo.imgAlt} src={imgInfo.loadingImg} /> : null}
            {children ? children : null}
        </div>
    </div>;
};

const ImageLink = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  imageArchor: imageArchor
}) => {
  const {
    src,
    link,
    linkInApp,
    linkOutApp,
    style,
    imageStyle,
    openNewWebview
  } = imageArchor;
  const {
    origin,
    pathname
  } = window.location;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + `#${envLink}` : envLink; // == 发送日志

  const sendLogRef = React.useRef((label = 'click') => {
    const pageId = window.__BUILDER_PAGE_ID;
    const logData = {
      topic_id: pageId,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id,
        sub: pageId
      }
    };

    if (isInApp) {
      qt.log.event({
        label,
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', label, logData);
    }
  });

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return finalLink ? <a style={style} className="lh-100 block" onClick={() => {
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}><img style={imageStyle} src={src} /></a> : <div style={style} className="lh-100"><img style={imageStyle} src={src} /></div>;
};

const wrapStyle = {
  fontSize: '14px',
  textAlign: 'center',
  vertAlign: 'middle',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const RenderRule = ({
  basicConfig: basicConfig,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  let width = basicConfig.coverImgWidth,
      height = basicConfig.coverImgHeight,
      top = basicConfig.coverImgTop,
      right = basicConfig.coverImgRight,
      bottom = basicConfig.coverImgBottom,
      left = basicConfig.coverImgLeft,
      unit = basicConfig.unit;

  if (unit !== 'px') {
    width = width + unit;
    height = height + unit;
    top = top + unit;
    right = right + unit;
    bottom = bottom + unit;
    left = left + unit;
  }

  let ruleStyle = Object.assign({}, wrapStyle, {
    width,
    height,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    position: basicConfig.position,
    zIndex: basicConfig.zIndex
  });

  if (basicConfig.position === 'fixed' || basicConfig.position === 'absolute') {
    ruleStyle = Object.assign({}, wrapStyle, {
      width,
      height,
      top,
      right,
      bottom,
      left,
      position: basicConfig.position,
      zIndex: basicConfig.zIndex
    });
  }

  const isInApp = qt.env.inApp;
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  const imgStyle = {
    width,
    height
  };
  const contentStyle = {
    lineHeight: basicConfig.lineHeight,
    whiteSpace: 'pre-wrap',
    height: basicConfig.ruleContentHeight ? basicConfig.ruleContentHeight + basicConfig.unit : '',
    maxHeight: basicConfig.ruleContentMaxHeight ? basicConfig.ruleContentMaxHeight + basicConfig.unit : '',
    textAlign: 'left',
    overflowY: 'auto',
    fontSize: basicConfig.ruleFontSize
  };
  return <Fragment>
        <div style={ruleStyle} onClick={() => {
      if (isInApp) {
        qt.log.event({
          label: 'click',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'click', logData);
      }

      Modal.show({
        title: '活动规则',
        jsxContent: <div style={contentStyle} dangerouslySetInnerHTML={{
          __html: basicConfig.ruleContent
        }}></div>,
        showTopPic: false,
        okText: '知道了',
        onOk: () => {},
        showCancel: false
      });
    }}>
            {children ? children : <img style={imgStyle} alt={"rule-cover"} src={basicConfig.coverImg} />}
        </div>
    </Fragment>;
};

const RenderShare = ({
  id = "",
  nodeId = "",
  nodeType = "",
  basicConfig: basicConfig
}) => {
  const {
    style,
    imgUrl,
    showOutApp,
    shareConfig: {
      title,
      desc,
      img,
      link
    }
  } = basicConfig; // == 点击事件

  const imgClick = () => {
    const logData = {
      topic_id: window.__BUILDER_PAGE_ID,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id
      }
    };

    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    qt.share({
      title,
      desc,
      imageUrl: img,
      link: link || window.location.href
    });
  };

  return qt.env.inApp ? <img style={style} alt={"share-cover"} src={imgUrl} onClick={() => imgClick()} /> : showOutApp ? <img style={style} alt={"share-cover"} src={imgUrl} onClick={() => imgClick()} /> : null;
};

const RenderVideo = ({
  basicConfig: basicConfig,
  videoConfig: videoConfig,
  id: id
}) => {
  let {
    width,
    height,
    top,
    bottom,
    left,
    right,
    unit
  } = basicConfig;
  const [videojs, setVideojs] = useState__5(null);
  useEffect(() => {
    import('video.js/dist/video.js').then(fileres => {
      setVideojs(fileres);
    });
  }, []);

  if (basicConfig.unit !== 'px') {
    width = width + unit;
    height = height + unit;
    top = top + unit;
    right = right + unit;
    bottom = bottom + unit;
    left = left + unit;
  }

  let style = {
    display: basicConfig.display,
    width,
    height,
    position: basicConfig.position,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    zIndex: basicConfig.zIndex,
    overflow: 'hidden'
  };
  const containerStyle = {
    padding: 0,
    width: '100%'
  };

  if (basicConfig.position === 'absolute' || basicConfig.position === 'fixed') {
    style = {
      display: basicConfig.display,
      width,
      height,
      position: basicConfig.position,
      top,
      right,
      bottom,
      left,
      zIndex: basicConfig.zIndex,
      overflow: 'hidden'
    };
  }

  const imgStyle = {
    width: basicConfig.width,
    height: basicConfig.height,
    display: 'block'
  };
  const contentStyle = {
    width: '100%',
    height: '200px',
    background: '#000'
  };
  let isiOS = /(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent) || qt.env.inIosApp;

  const VideoAndiro = () => {
    return <video id={id} // className="video-js"
    autoplay={"autoplay"} style={{
      width: '100%',
      height: '200px',
      outline: 'none',
      overflow: 'hidden'
    }} controls="controls" poster={"https://sss.staging.qingting.fm/qt-builder-manage/upload_342a7a297db082f0eadf12aaf0181ca1.png"}>
                {videoConfig.videoMp4Url ? <source src={videoConfig.videoMp4Url} type="video/mp4"></source> : null}
                {videoConfig.videoOggUrl ? <source src={videoConfig.videoOggUrl} type="video/ogg"></source> : null}
                {videoConfig.videoWebmUrl ? <source src={videoConfig.videoWebmUrl} type="video/webm"></source> : null}
                <p>
                    To view this video please enable JavaScript, and consider upgrading to a
                    web browser that
                </p>
            </video>;
  };

  const VideoDom = () => {
    if (isiOS) {
      return <video id={id} className="video-js" style={{
        width: 0,
        height: 0,
        outline: 'none',
        overflow: 'hidden',
        opacity: 0
      }} controls="controls" poster={videoConfig.videoPoster}>
                {videoConfig.videoMp4Url ? <source src={videoConfig.videoMp4Url} type="video/mp4"></source> : null}
                {videoConfig.videoOggUrl ? <source src={videoConfig.videoOggUrl} type="video/ogg"></source> : null}
                {videoConfig.videoWebmUrl ? <source src={videoConfig.videoWebmUrl} type="video/webm"></source> : null}
                <p>
                    To view this video please enable JavaScript, and consider upgrading to a
                    web browser that
                </p>
            </video>;
    } else {
      return null;
    }
  };

  const playVideo = () => {
    if (isiOS) {
      if (videoConfig.videoMp4Url || videoConfig.videoOggUrl || videoConfig.videoWebmUrl) {
        const domId = document.getElementById(id);
        let player = videojs.default(domId);
        player.play();
      }
    } else {
      Modal.show({
        title: '',
        jsxContent: <div style={contentStyle}>
                    {VideoAndiro()}
                </div>,
        backStyle: {
          background: 'rgba(0,0,0,.9)'
        },
        showTopPic: false,
        okText: '',
        containerStyle: containerStyle,
        footer: <span></span>,
        onOk: () => {},
        showCancel: false,
        showCloseIcon: true
      });
      setTimeout(() => {
        if (videoConfig.videoMp4Url || videoConfig.videoOggUrl || videoConfig.videoWebmUrl) {
          const domId = document.getElementById(id);
          let player = videojs.default(domId);
          player.play();
        }
      }, 0);
    }
  };

  return <div>
        <div style={style} onClick={() => {
      playVideo();
    }}>
            <img style={imgStyle} alt={"封面图"} src={videoConfig.videoPoster || 'https://sss.staging.qingting.fm/qt-builder-manage/upload_6af6b3971f2a547c9b093da5dfcb7b20.png'} />
        </div>
        {VideoDom()}
    </div>;
};

const transferTime = time => {
  if (!time) return null;
  return new Date(Date.parse(time.replace(/-/g, '/')));
};

const TimeController = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__6(isDisplay); // == 实时更新开启以及当前时间在结束时间或者开始时间之前才开启

  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const groupType = "onlyNoAutoRenew";
let groupCache = undefined;

const MemberGroup = ({ ...contents
}) => {
  const [group, setGroup] = useState__7();
  const [isLoading, setIsLoading] = useState__7(true); // 防止屏幕内容闪烁

  const baseUrl = `https://webapi.qingting.fm`;
  useEffect__7(() => {
    if (groupCache !== undefined) return;
    let userId = '',
        deviceId = '',
        token = '';
    qt.getUserId({
      realNameUserOnly: true
    }).then(id => {
      if (id) {
        userId = id;

        if (qt.env.inApp) {
          return Promise.all([qt.getDevice(), qt.getAccessToken()]);
        }
      } else {
        setGroup(1);
        groupCache = 1;
        setIsLoading(false);
      }

      return Promise.resolve();
    }).then(res => {
      if (res) {
        deviceId = res[0].deviceId;
        token = res[1];
      }

      return axios.get(baseUrl + '/material/frontend/423/check-user-benefit', {
        params: {
          user_id: userId,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      });
    }).then(data => {
      if (data && data.data && data.data.data && data.data.data.in_autorenew) {
        setGroup(0);
        groupCache = 0;
      } else {
        setGroup(1);
        groupCache = 1;
      }

      setIsLoading(false);
    });
  }, []);
  return <div>
    {!contents || !contents.children || contents.children.length === 0 ? <div>请添加子组件</div> : groupType === 'normal' ? contents.children.length >= 2 ? !isLoading ? group === 0 ? contents.children[0] : contents.children[1] : null : <div>子组件至少两个</div> : groupType === 'onlyAutoRenew' ? group === 0 ? contents.children : null : groupType === 'onlyNoAutoRenew' ? group === 1 ? contents.children : null : null}
  </div>;
};

const CommonImage = ({
  config: config,
  sendLog: sendLog
}) => {
  const {
    openLazyload,
    openExpose
  } = config;
  const imgRef = React.useRef();
  const [measure, setMeasure] = React.useState();
  const [load, setLoad] = React.useState(false);
  const [exposed, setExposed] = React.useState(false);

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  React.useEffect(() => {
    if (!config.src) return;
    window.addEventListener("load", () => {
      const elem = imgRef.current;
      if (!elem) return;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollTop = getScrollTop();
      const offsetTop = scrollTop + elem.getBoundingClientRect().top;
      const initMeasure = {
        offsetTop,
        windowHeight,
        load: scrollTop + windowHeight >= offsetTop
      };
      setMeasure(initMeasure);
    });
  }, []); // == 懒加载监听

  React.useEffect(() => {
    if (!openLazyload || !measure || measure.load || load) return;
    const {
      offsetTop,
      windowHeight
    } = measure;

    const lazyloadListener = () => {
      const scrollTop = getScrollTop();
      const isLoad = scrollTop + windowHeight >= parseInt(offsetTop) - 30; // 提前30像素加载

      if (isLoad) setLoad(isLoad);
    };

    window.addEventListener('scroll', lazyloadListener);
    return () => {
      window.removeEventListener('scroll', lazyloadListener);
    };
  }, [measure, load]); // == 曝光监听

  React.useEffect(() => {
    if (!openExpose || !measure || exposed) return;
    const isImageLoad = !openLazyload || measure.load || load; // == 懒加载情况下，图片未加载不开启曝光监听

    if (!isImageLoad) return;
    let height = imgRef.current.getBoundingClientRect().height;
    const {
      offsetTop,
      windowHeight
    } = measure;

    const exposeListener = () => {
      const scrollTop = getScrollTop();
      height = height > 0 ? height : imgRef.current.getBoundingClientRect().height; // == 图片50%露出才曝光

      const isExposeTop = scrollTop >= offsetTop + height / 2 - windowHeight;
      const isExposeBottom = scrollTop < offsetTop + height / 2;
      const isExpose = isExposeTop && isExposeBottom;
      if (!isExpose) return;
      sendLog('expose');
      setExposed(true); // == 10秒后再次开启曝光

      setTimeout(() => setExposed(false), 10000);
    };

    exposeListener();
    window.addEventListener('scroll', exposeListener);
    return () => {
      window.removeEventListener('scroll', exposeListener);
    };
  }, [measure, load, exposed]);
  return config.src ? openLazyload ? <img ref={imgRef} className={`block lh-100 ${measure && measure.load || load ? '' : 'invisible '}${config.isCenter ? 'm-auto' : ''}`} width={config.widthType === 'percent' ? `${config.width}%` : config.width} src={measure && measure.load || load ? config.src : null} /> : <img ref={imgRef} className={`block lh-100 ${config.isCenter ? 'm-auto' : ''}`} width={config.widthType === 'percent' ? `${config.width}%` : config.width} src={config.src} /> : <div className="text-center mv-3 f14">请添加图片</div>;
};

const SingleImage = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  config: config,
  containerStyle: containerStyle,
  children: children
}) => {
  const {
    origin,
    pathname
  } = window.location;
  const {
    link,
    linkInApp,
    linkOutApp,
    openNewWebview
  } = config;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + `#${envLink}` : envLink;
  const pageId = window.__BUILDER_PAGE_ID; // == 发送日志

  const sendLogRef = React.useRef((label = 'click') => {
    const logData = {
      topic_id: pageId,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id,
        sub: pageId
      }
    };

    if (isInApp) {
      qt.log.event({
        label,
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', label, logData);
    }
  });
  return finalLink ? <a id={id} className="block relative" style={containerStyle} onClick={() => {
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}>
      <CommonImage sendLog={sendLogRef.current} config={config} />
      {children}
    </a> : <div id={id} className="relative" style={containerStyle}>
      <CommonImage sendLog={sendLogRef.current} config={config} />
      {children}
    </div>;
};

const TextLink = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  textArchor: textArchor
}) => {
  const {
    title,
    link,
    linkInApp,
    linkOutApp,
    textStyle,
    positionStyle,
    openNewWebview
  } = textArchor;
  const {
    origin,
    pathname
  } = window.location;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + `#${envLink}` : envLink; // == 发送日志

  const sendLogRef = React.useRef((label = 'click') => {
    const pageId = window.__BUILDER_PAGE_ID;
    const logData = {
      topic_id: pageId,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id,
        sub: pageId
      }
    };

    if (isInApp) {
      qt.log.event({
        label,
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', label, logData);
    }
  });

  if (positionStyle.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = positionStyle;
    positionStyle.top = top ? `${top}rem` : top;
    positionStyle.bottom = bottom ? `${bottom}rem` : bottom;
    positionStyle.left = left ? `${left}rem` : left;
    positionStyle.right = right ? `${right}rem` : right;
  }

  delete positionStyle.type;
  const style = { ...textStyle,
    ...positionStyle
  };
  return finalLink ? <a style={style} className="lh-100 block" onClick={() => {
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}>{title}</a> : <div style={style} className="lh-100">{title}</div>;
};

const TextLink__13 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  textArchor: textArchor
}) => {
  const {
    title,
    link,
    linkInApp,
    linkOutApp,
    textStyle,
    positionStyle,
    openNewWebview
  } = textArchor;
  const {
    origin,
    pathname,
    search
  } = window.location;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + search + `#${envLink}` : envLink; // == 发送日志

  const sendLogRef = React.useRef((label = 'click') => {
    const pageId = window.__BUILDER_PAGE_ID;
    const logData = {
      topic_id: pageId,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id,
        sub: pageId
      }
    };

    if (isInApp) {
      qt.log.event({
        label,
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', label, logData);
    }
  });

  if (positionStyle.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = positionStyle;
    positionStyle.top = top ? `${top}rem` : top;
    positionStyle.bottom = bottom ? `${bottom}rem` : bottom;
    positionStyle.left = left ? `${left}rem` : left;
    positionStyle.right = right ? `${right}rem` : right;
  }

  delete positionStyle.type;
  const style = { ...textStyle,
    ...positionStyle
  };
  return finalLink ? <a style={style} className="lh-100 block" onClick={() => {
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}>{title}</a> : <div style={style} className="lh-100">{title}</div>;
};

const BaseLayout = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    commonStyle,
    positionStyle,
    spacingStyle
  } = config;
  const {
    background
  } = commonStyle;
  const style = { ...commonStyle,
    ...positionStyle,
    ...spacingStyle
  }; // == 背景设置

  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color; // == rem单位处理

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return children ? <div id={id} style={style}>{children}</div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const productId = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const isBenefit = false;
const isAbsolute = false;
const popLog = true;
const unit = "px";
const position = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_f53e9a8fb6eefe13bb7c5b15fbe0fefc.png",
  bgColor: "transparent",
  width: 260,
  height: 60
};
const text = {
  content: "",
  color: "transparent",
  fontSize: 16
};
const hasAnimation = true;

const BuyButton = ({
  text: text,
  btnStyle: btnStyle,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = React.createRef();
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  }; // == 防止重复曝光打点

  let hasTrack = false;
  useEffect(() => {
    if (popLog) popTrack();

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const purchase = () => {
    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId.iosId
      };
    } else {
      param = {
        itemId: productId.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            }
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const popTrack = () => {
    if (hasTrack) return;
    const pos = buttonRef.current.getBoundingClientRect();

    if (pos.bottom <= window.innerHeight) {
      if (qt.env.inApp) {
        qt.log.event({
          label: 'view',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'view', logData);
      }

      hasTrack = true;
    }
  };

  if (popLog) {
    window.addEventListener('scroll', popTrack);
  }

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle} onClick={() => purchase()} ref={buttonRef}>{text}</div>
  </div>;
};

const EnvController = ({
  id: id,
  children: children,
  config: config
}) => {
  const [display, setDisplay] = useState__16(false);
  const {
    version,
    comparison,
    versionEnv,
    env,
    operation,
    versionOperation
  } = config;
  useEffect(() => {
    // == 环境控制，白名单取正，黑名单取反
    const envDisplay = env === 'all' ? operation === 'allow' : operation === 'allow' ? qt.env[env] : !qt.env[env];
    if (!qt.env.inApp || !version) return setDisplay(envDisplay);
    qt.compareAppVersion(version).then(comparisons => {
      // == 版本匹配白名单则显示，黑名单取反
      const versionDisplay = versionOperation === 'allow' ? comparisons[comparison] : !comparisons[comparison]; // == 环境匹配

      const isMatched = qt.env[versionEnv]; // == 未选不限环境且对应环境不匹配则不做版本控制

      if (versionEnv !== 'all' && !isMatched) return setDisplay(envDisplay);
      setDisplay(envDisplay && versionDisplay);
    });
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const TimeController__17 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__17(isDisplay); // == 实时更新开启以及当前时间在结束时间或者开始时间之前才开启

  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const MemberGroup__18 = ({ ...contents
}) => {
  const [group, setGroup] = useState__18();
  const [isLoading, setIsLoading] = useState__18(true); // 防止屏幕内容闪烁

  const baseUrl = `https://webapi.qingting.fm`;
  useEffect__18(() => {
    if (groupCache !== undefined) return;
    let userId = '',
        deviceId = '',
        token = '';
    qt.getUserId({
      realNameUserOnly: true
    }).then(id => {
      if (id) {
        userId = id;

        if (qt.env.inApp) {
          return Promise.all([qt.getDevice(), qt.getAccessToken()]);
        }
      } else {
        setGroup(1);
        groupCache = 1;
        setIsLoading(false);
      }

      return Promise.resolve();
    }).then(res => {
      if (res) {
        deviceId = res[0].deviceId;
        token = res[1];
      }

      return axios.get(baseUrl + '/material/frontend/423/check-user-benefit', {
        params: {
          user_id: userId,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      });
    }).then(data => {
      if (data && data.data && data.data.data && data.data.data.in_autorenew) {
        setGroup(0);
        groupCache = 0;
      } else {
        setGroup(1);
        groupCache = 1;
      }

      setIsLoading(false);
    });
  }, []);
  return <div>
    {!contents || !contents.children || contents.children.length === 0 ? <div>请添加子组件</div> : groupType === 'normal' ? contents.children.length >= 2 ? !isLoading ? group === 0 ? contents.children[0] : contents.children[1] : null : <div>子组件至少两个</div> : groupType === 'onlyAutoRenew' ? group === 0 ? contents.children : null : groupType === 'onlyNoAutoRenew' ? group === 1 ? contents.children : null : null}
  </div>;
};

const ImageLink__20 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  imageArchor: imageArchor
}) => {
  const {
    src,
    link,
    linkInApp,
    linkOutApp,
    style,
    imageStyle,
    openNewWebview
  } = imageArchor;
  const {
    origin,
    pathname,
    search
  } = window.location;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + search + `#${envLink}` : envLink; // == 发送日志

  const sendLogRef = React.useRef((label = 'click') => {
    const pageId = window.__BUILDER_PAGE_ID;
    const logData = {
      topic_id: pageId,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id,
        sub: pageId
      }
    };

    if (isInApp) {
      qt.log.event({
        label,
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', label, logData);
    }
  });

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return finalLink ? <a style={style} className="lh-100 block" onClick={() => {
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}><img style={imageStyle} src={src} /></a> : <div style={style} className="lh-100"><img style={imageStyle} src={src} /></div>;
};

const ImageLink__21 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  imageArchor: imageArchor
}) => {
  const {
    src,
    link,
    linkInApp,
    linkOutApp,
    style,
    imageStyle,
    openNewWebview
  } = imageArchor;
  const {
    origin,
    pathname,
    search
  } = window.location;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + search + `#${envLink}` : envLink;
  const sendLogRef = React.useRef((label = 'click') => {
    const pageId = window.__BUILDER_PAGE_ID;
    const logData = {
      topic_id: pageId,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id,
        sub: pageId
      }
    };

    if (isInApp) {
      qt.log.event({
        label,
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', label, logData);
    }
  });

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return finalLink ? <a style={style} className="lh-100 block" onClick={() => {
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}><img style={imageStyle} src={src} /></a> : <div style={style} className="lh-100"><img style={imageStyle} src={src} /></div>;
};

const productId__23 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const position__23 = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle__23 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_e0dc755482b47984129d16c18f87848b.png",
  bgColor: "transparent",
  width: 260,
  height: 60
};
const text__23 = {
  content: "",
  color: "transparent",
  fontSize: 16
};

const BuyButton__23 = ({
  text: text__23,
  btnStyle: btnStyle__23,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = React.createRef();
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  let hasTrack = false;
  useEffect(() => {
    if (popLog) popTrack();

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const purchase = () => {
    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__23.iosId
      };
    } else {
      param = {
        itemId: productId__23.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            }
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const popTrack = () => {
    if (hasTrack) return;
    const pos = buttonRef.current.getBoundingClientRect();

    if (pos.bottom <= window.innerHeight) {
      if (qt.env.inApp) {
        qt.log.event({
          label: 'view',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'view', logData);
      }

      hasTrack = true;
    }
  };

  if (popLog) {
    window.addEventListener('scroll', popTrack);
  }

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__23} onClick={() => purchase()} ref={buttonRef}>{text__23}</div>
  </div>;
};

const TimeController__24 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__24(isDisplay);
  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const MemberGroup__25 = ({ ...contents
}) => {
  const [group, setGroup] = useState__25();
  const [isLoading, setIsLoading] = useState__25(true);
  const baseUrl = `https://webapi.qingting.fm`;
  useEffect__25(() => {
    if (groupCache !== undefined) return;
    let userId = '',
        deviceId = '',
        token = '';
    qt.getUserId({
      realNameUserOnly: true
    }).then(id => {
      if (id) {
        userId = id;

        if (qt.env.inApp) {
          return Promise.all([qt.getDevice(), qt.getAccessToken()]);
        }
      } else {
        setGroup(1);
        groupCache = 1;
        setIsLoading(false);
      }

      return Promise.resolve();
    }).then(res => {
      if (res) {
        deviceId = res[0].deviceId;
        token = res[1];
      }

      return axios.get(baseUrl + '/material/frontend/423/check-user-benefit', {
        params: {
          user_id: userId,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      });
    }).then(data => {
      if (data && data.data && data.data.data && data.data.data.in_autorenew) {
        setGroup(0);
        groupCache = 0;
      } else {
        setGroup(1);
        groupCache = 1;
      }

      setIsLoading(false);
    });
  }, []);
  return <div>
    {!contents || !contents.children || contents.children.length === 0 ? <div>请添加子组件</div> : groupType === 'normal' ? contents.children.length >= 2 ? !isLoading ? group === 0 ? contents.children[0] : contents.children[1] : null : <div>子组件至少两个</div> : groupType === 'onlyAutoRenew' ? group === 0 ? contents.children : null : groupType === 'onlyNoAutoRenew' ? group === 1 ? contents.children : null : null}
  </div>;
};

const productId__29 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const unit__29 = "rem";
const position__29 = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle__29 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_d0d44142879200e6584c622ef2a82e7d.png",
  bgColor: "transparent",
  width: 2,
  height: 0.7
};
const text__29 = {
  content: "",
  color: "transparent",
  fontSize: 16
};

const BuyButton__29 = ({
  text: text__29,
  btnStyle: btnStyle__29,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = React.createRef();
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  let hasTrack = false;
  useEffect(() => {
    if (popLog) popTrack();

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const purchase = () => {
    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__29.iosId
      };
    } else {
      param = {
        itemId: productId__29.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            }
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const popTrack = () => {
    if (hasTrack) return;
    const pos = buttonRef.current.getBoundingClientRect();

    if (pos.bottom <= window.innerHeight) {
      if (qt.env.inApp) {
        qt.log.event({
          label: 'view',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'view', logData);
      }

      hasTrack = true;
    }
  };

  if (popLog) {
    window.addEventListener('scroll', popTrack);
  }

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__29} onClick={() => purchase()} ref={buttonRef}>{text__29}</div>
  </div>;
};

const BaseLayout__30 = ({
  children: children,
  config: config
}) => {
  const {
    commonStyle,
    positionStyle,
    spacingStyle
  } = config;
  const {
    background
  } = commonStyle;
  delete commonStyle.background;
  const style = { ...commonStyle,
    ...positionStyle,
    ...spacingStyle
  }; // == 背景处理

  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color; // == rem单位处理

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return children ? <div style={style}>{children}</div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const SwiperContainer = ({
  id: id,
  type = "base",
  config: config,
  children: children
}) => {
  const [fileData, setFileData] = useState__32();
  const ref = useRef(); // == 容器高度

  const height = config.swiper.height; // == 类型配置集合

  const typeConfigs = {
    [type]: {
      loop: config.swiper.loop,
      autoplay: config.swiper.autoplay ? {
        disableOnInteraction: false
      } : false,
      delay: config.swiper.delay,
      centeredSlides: config.swiper.centeredSlides,
      direction: config.swiper.direction
    }
  };

  if (type === 'multi' || type === 'scale') {
    typeConfigs[type].slidesPerView = config.swiper.slidesPerView;
    typeConfigs[type].spaceBetween = config.swiper.spaceBetween;
  } // == 按需加载swiper.js


  useEffect__32(() => {
    import('swiper').then(fileData => {
      setFileData(fileData);
    });
  }, []);

  const findEventHandlers = elem => {
    for (const key of Object.keys(elem)) {
      if (key.indexOf('__reactEventHandlers') > -1) return elem[key];
    }
  };

  const findTargetSlideByIndex = (slides, index) => {
    for (let i = 0, n = slides.length; i < n; i++) {
      const slide = slides[i];
      const handlers = findEventHandlers(slide);
      if (handlers && slide.dataset.swiperSlideIndex === index) return slide;
    }
  };

  const cycleBindEvent = (node, targetNode) => {
    const handlerTree = findEventHandlers(targetNode);

    if (handlerTree && handlerTree.onClick) {
      node.onclick = handlerTree.onClick;
    }

    if (node.childNodes && node.childNodes.length) {
      for (let i = 0, n = node.childNodes.length; i < n; i++) {
        const childNode = node.childNodes[i];
        const targetChildNode = targetNode.childNodes[i];
        cycleBindEvent(childNode, targetChildNode);
      }
    }
  };

  useEffect__32(() => {
    if (!fileData) return;
    const swiper = new fileData.default(ref.current, typeConfigs[type]);

    for (let i = 0, n = swiper.slides.length; i < n; i++) {
      const slide = swiper.slides[i];
      const handlersTree = findEventHandlers(slide);
      if (handlersTree) continue;
      const targetSlide = findTargetSlideByIndex(swiper.slides, slide.dataset.swiperSlideIndex);
      cycleBindEvent(slide, targetSlide);
    }
  }, [fileData]);
  const components = children ? children.length ? children : [children] : [];
  return children ? <div id={id}>
      <style>{`#swiper-${id}.swiper-container,#swiper-${id}.swiper-container,#swiper-${id}.swiper-container{height:${height > 0 ? height + 'px' : 'auto'};}
#swiper-${id}.swiper-scale .swiper-slide {transition: 300ms;-webkit-transition: 300ms;transform: scale(0.8);-webkit-transform: scale(0.8);transform-origin:center 80%;-webkit-transform-origin:center 80%;}
#swiper-${id}.swiper-scale .swiper-slide-active,#swiper-${id}.swiper-scale .swiper-slide-duplicate-active{-webkit-transform: scale(1);transform: scale(1);z-index:5;}
      `}</style>
      <div id={`swiper-${id}`} ref={ref} className={`swiper-container swiper-${type}`} style={{
      display: fileData ? 'block' : 'none'
    }}>
        <div className="swiper-wrapper">
          {components.map((comp, index) => {
          const isDynamic = typeof comp.type === 'function' && comp.props && comp.props.dynamicSwiper;
          const isLoop = typeConfigs[type] && typeConfigs[type].loop;
          return <div key={index} className="swiper-slide" style={config.style}>
              {isDynamic && isLoop ? React.cloneElement(comp, {
              initSwiper: () => {
                if (fileData) new fileData.default(ref.current, typeConfigs[type]);
              }
            }) : comp}
            </div>;
        })}
        </div>
      </div>
    </div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加轮播子组件</div>;
};

const TimeController__36 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__36(isDisplay);
  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const TimeController__39 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__39(isDisplay);
  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const Button = (close = () => {}) => {
  return <div onClick={() => {
    close();
  }} style={{
    backgroundImage: 'linear-gradient(-135deg, #FF8A8A 0%, #FD5353 100%)',
    borderRadius: '20px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '40px',
    marginTop: '16px'
  }}>
        <div style={{
      height: '20px'
    }}><img style={{
        width: '20px'
      }} src={"https://sss.staging.qingting.fm/qt-builder-manage/upload_f233ad9be29cd0eb6ef09cf8d7e1cbef.png"} /></div>
        <div style={{
      color: '#fff',
      fontSize: '16px'
    }}>开启手机通知</div>
    </div>;
};

const RenderReserve = ({
  basicConfig: basicConfig,
  styleConfig: styleConfig,
  id: id,
  nodeId: nodeId,
  nodeType: nodeType
}) => {
  const [isReserved, setReserved] = useState__42(false); //获取用户信息

  const getUserInfo = async () => {
    try {
      let userId = await qt.getUserId();
      let res = (await qt.getDevice()) || '';
      const deviceId = res.deviceId;
      return {
        userId: userId || '',
        deviceId: deviceId
      };
    } catch (e) {
      return {
        userId: '',
        deviceId: ''
      };
    }
  };

  const host = basicConfig.isStaging ? 'https://ac.staging.qingting.fm/v1/user/appointment' : 'https://ac.qingting.fm/v1/user/appointment'; // 当前是否预约

  const getIsReserve = async () => {
    try {
      let {
        userId,
        deviceId
      } = await getUserInfo();
      const task = basicConfig.taskIds.split(',').join('&task_ids=');
      const res = await axios.get(`${host}?task_ids=${task}&device_id=${deviceId}&userId=${userId}`);
      const result = get(res, 'data.data');
      setReserved(result);
    } catch (e) {
      console.log(e);
    }
  };

  const isInApp = qt.env.inApp;
  let {
    imgWidth,
    imgHeight,
    top,
    bottom,
    left,
    right,
    unit,
    position,
    display,
    zIndex
  } = styleConfig;

  if (unit !== 'px') {
    imgWidth = imgWidth + unit;
    imgHeight = imgHeight + unit;
    top = top + unit;
    bottom = bottom + unit;
    left = left + unit;
    right = right + unit;
  }

  let wrapStyle = {
    width: imgWidth,
    height: imgHeight,
    display,
    marginTop: top,
    marginBottom: bottom,
    marginRight: right,
    marginLeft: left,
    overflow: 'hidden',
    position,
    zIndex
  };

  if (position === 'absolute' || position === 'fixed') {
    wrapStyle = {
      width: imgWidth,
      height: imgHeight,
      display,
      top,
      bottom,
      right,
      left,
      overflow: 'hidden',
      position,
      zIndex
    };
  }

  const imgStyle = {
    width: imgWidth,
    display: 'block'
  };

  const isOpen = async () => {
    try {
      const open = await qt.checkNotification({
        forceRequest: true
      });

      if (open) {
        Toast.info({
          content: '开启成功',
          duration: 3000,
          onClose: () => {}
        });
      }

      return;
    } catch (e) {
      console.log(e);
    }
  };

  window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
    type: 'live'
  }, null);
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  }; //去设置按钮的log数据

  const btnLogData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    type: 'modal-btn',
    pos: {
      type: nodeType,
      name: id
    }
  }; //弹窗的曝光数据

  const modalLogData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    type: 'modal-notice',
    pos: {
      type: nodeType,
      name: id
    }
  };

  const closeModal = () => {
    if (isInApp) {
      qt.log.event({
        label: 'click',
        data: btnLogData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', btnLogData);
    }

    Modal.close();
    setTimeout(() => {
      return isOpen(); // return open(isOpen)
    }, 0);
  };

  useEffect(() => {
    if (isInApp) {
      qt.log.event({
        label: 'view',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'view', logData);
    }

    if (isInApp) {
      getIsReserve();
    }

    return () => {
      localStorage.removeItem('global_reserve_back');
    };
  }, []); //检查是否开通通知权限

  const checkNotificationPermission = async data => {
    // const newData = JSON.parse(data)
    // const code = newData.code
    try {
      const isOpen = await qt.checkNotification({
        forceRequest: false
      });

      if (!isOpen) {
        if (basicConfig.pushType) {
          if (isInApp) {
            qt.log.event({
              label: 'view',
              data: modalLogData
            });
          } else {
            qtWebLog.push('_trackEvent', 'view', modalLogData);
          }

          Modal.show({
            title: '开启通知',
            subTitle: basicConfig.modalMessage || '开启后第一时间收听上新音频',
            bottomTip: '',
            showTopPic: true,
            okText: '提交',
            onOk: () => {},
            footer: Button(closeModal),
            showCancel: true,
            cancelText: '关闭',
            showCloseIcon: true,
            topImg: 'https://sss.staging.qingting.fm/qt-builder-manage/upload_1f7e5407b843ed6c871d629a44079a38.png',
            onCancel: () => {}
          });
        }
      }

      return;
    } catch (e) {
      console.log(e);
    }
  };

  const isShowReserve = !isExpire(basicConfig.endTime) && !isNotStart(basicConfig.startTime);
  const imgUrl = isReserved ? basicConfig.reservedImg : basicConfig.unReserveImg;

  const gotoReserve = async () => {
    try {
      let {
        userId,
        deviceId = ''
      } = await getUserInfo();
      const task = basicConfig.taskIds.split(',');
      const numberTaskIds = task.map(Number);
      const response = await axios.put(`${host}`, {
        user_id: userId,
        device_id: deviceId,
        task_ids: numberTaskIds
      }); //判断通知权限有木有，并且是不是需要开启预约权限

      const errorCode = get(response, 'data.errcode', '');
      const errmsg = get(response, 'data.errmsg', '预约失败');

      if (errorCode === 0) {
        setReserved(true);
        setTimeout(() => {
          return checkNotificationPermission(); // return check(checkNotificationPermission)
        }, 0);
      } else {
        Toast.info({
          content: errmsg,
          duration: 3000,
          onClose: () => {}
        });
      }
    } catch (e) {
      Toast.info({
        content: '接口请求失败，请稍后重试',
        duration: 3000,
        onClose: () => {}
      });
    }
  };

  return isShowReserve ? <div onClick={async () => {
    if (isInApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    } // 已预约，则不能点击


    if (isReserved) return;

    if (isInApp) {
      let {
        userId
      } = await getUserInfo();

      if (basicConfig.isNeedLogin && !userId) {
        qt.login({
          success: () => {
            return gotoReserve();
          }
        });
      } else {
        return gotoReserve();
      }
    } else {
      window.linkedme.generate({
        type: 'h5',
        h5Url: window.location.href
      }).then(res => {
        window.linkedme.trigger(res.url);
      });
    }
  }} style={wrapStyle} id={id}>
        <img style={imgStyle} src={imgUrl} alt="reserve" />
    </div> : null;
};

const HorizontalLayout = ({
  id: id,
  config: config,
  children: children
}) => {
  const {
    wrap,
    horizontalCss,
    verticalCss,
    commonStyle,
    positionStyle,
    spacingStyle
  } = config;
  const {
    background
  } = commonStyle;
  delete commonStyle.background;
  const style = { ...commonStyle,
    ...positionStyle,
    ...spacingStyle
  }; // == 背景处理

  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color; // == rem单位处理

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return children ? <div id={id} className={`flex${horizontalCss ? ' ' + horizontalCss : ''}${verticalCss ? ' ' + verticalCss : ''}${wrap ? ' flex-wrap' : ' '}`} style={style}>
      {children}
    </div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const HorizontalLayout__47 = ({
  config: config,
  children: children
}) => {
  const {
    wrap,
    horizontalCss,
    verticalCss,
    commonStyle,
    positionStyle,
    spacingStyle
  } = config;
  const {
    background
  } = commonStyle;
  delete commonStyle.background;
  const style = { ...commonStyle,
    ...positionStyle,
    ...spacingStyle
  };
  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color;

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return children ? <div className={`flex${horizontalCss ? ' ' + horizontalCss : ''}${verticalCss ? ' ' + verticalCss : ''}${wrap ? ' flex-wrap' : ' '}`} style={style}>
      {children}
    </div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const TimeController__52 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__52(isDisplay);
  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const groupType__53 = "onlyAutoRenew";

const MemberGroup__53 = ({ ...contents
}) => {
  const [group, setGroup] = useState__53();
  const [isLoading, setIsLoading] = useState__53(true);
  const baseUrl = `https://webapi.qingting.fm`;
  useEffect__53(() => {
    if (groupCache !== undefined) return;
    let userId = '',
        deviceId = '',
        token = '';
    qt.getUserId({
      realNameUserOnly: true
    }).then(id => {
      if (id) {
        userId = id;

        if (qt.env.inApp) {
          return Promise.all([qt.getDevice(), qt.getAccessToken()]);
        }
      } else {
        setGroup(1);
        groupCache = 1;
        setIsLoading(false);
      }

      return Promise.resolve();
    }).then(res => {
      if (res) {
        deviceId = res[0].deviceId;
        token = res[1];
      }

      return axios.get(baseUrl + '/material/frontend/423/check-user-benefit', {
        params: {
          user_id: userId,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      });
    }).then(data => {
      if (data && data.data && data.data.data && data.data.data.in_autorenew) {
        setGroup(0);
        groupCache = 0;
      } else {
        setGroup(1);
        groupCache = 1;
      }

      setIsLoading(false);
    });
  }, []);
  return <div>
    {!contents || !contents.children || contents.children.length === 0 ? <div>请添加子组件</div> : groupType__53 === 'normal' ? contents.children.length >= 2 ? !isLoading ? group === 0 ? contents.children[0] : contents.children[1] : null : <div>子组件至少两个</div> : groupType__53 === 'onlyAutoRenew' ? group === 0 ? contents.children : null : groupType__53 === 'onlyNoAutoRenew' ? group === 1 ? contents.children : null : null}
  </div>;
};

const TextLink__59 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  textArchor: textArchor
}) => {
  const {
    title,
    link,
    linkInApp,
    linkOutApp,
    textStyle,
    positionStyle,
    openNewWebview
  } = textArchor;
  const {
    origin,
    pathname,
    search
  } = window.location;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + search + `#${envLink}` : envLink;
  const sendLogRef = React.useRef((label = 'click') => {
    const pageId = window.__BUILDER_PAGE_ID;
    const logData = {
      topic_id: pageId,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id,
        sub: pageId
      }
    };

    if (isInApp) {
      qt.log.event({
        label,
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', label, logData);
    }
  });

  if (positionStyle.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = positionStyle;
    positionStyle.top = top ? `${top}rem` : top;
    positionStyle.bottom = bottom ? `${bottom}rem` : bottom;
    positionStyle.left = left ? `${left}rem` : left;
    positionStyle.right = right ? `${right}rem` : right;
  }

  delete positionStyle.type;
  const style = { ...textStyle,
    ...positionStyle
  };
  return finalLink ? <a style={style} className="lh-100 block" onClick={() => {
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}>{title}</a> : <div style={style} className="lh-100">{title}</div>;
};

const getTime = endTime => {
  if (!endTime) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }

  const currentTime = new Date();
  const newEndTime = formatTime(endTime);
  const leftTime = new Date(newEndTime.valueOf() - currentTime.valueOf());
  const diff_time = leftTime / 1000;
  const days = parseInt(diff_time / 86400);
  const hours = parseInt(diff_time / 3600) - 24 * days;
  const minutes = parseInt(diff_time % 3600 / 60);
  const seconds = parseInt(diff_time % 60);
  return {
    days,
    hours,
    minutes,
    seconds
  };
};

const RenderCountDown = ({
  basicConfig: basicConfig
}) => {
  const expire = isExpire(basicConfig.endTime);
  let {
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    top,
    bottom,
    left,
    right,
    unit
  } = basicConfig;

  if (unit !== 'px') {
    paddingTop = paddingTop + unit;
    paddingBottom = paddingBottom + unit;
    paddingLeft = paddingLeft + unit;
    paddingRight = paddingRight + unit;
    top = top + unit;
    bottom = bottom + unit;
    left = left + unit;
    right = right + unit;
  }

  let style = {
    color: basicConfig.fontColor,
    background: basicConfig.bgColor,
    borderRadius: basicConfig.borderRadius,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    display: 'inline-block',
    fontWeight: basicConfig.fontWeight,
    fontSize: basicConfig.fontSize,
    position: basicConfig.position,
    marginTop: top,
    marginBottom: bottom,
    marginLeft: left,
    marginRight: right
  };

  if (basicConfig.position === 'absolute' || basicConfig.position === 'fixed') {
    style = {
      color: basicConfig.fontColor,
      background: basicConfig.bgColor,
      borderRadius: basicConfig.borderRadius,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight,
      display: basicConfig.display,
      fontWeight: basicConfig.fontWeight,
      fontSize: basicConfig.fontSize,
      position: basicConfig.position,
      top,
      bottom,
      left,
      right
    };
  }

  const [leftTime, setLeftTime] = useState__61({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    if (!basicConfig.endTime) return;

    let timeOut = () => {
      const expire = isExpire(basicConfig.endTime);
      if (expire) return;
      setTimeout(() => {
        let time = getTime(basicConfig.endTime);
        setLeftTime(time);
        timeOut();
      }, 1000);
    };

    timeOut();
  }, []);
  return basicConfig.isCustomizeEndTitle && expire ? <div style={style}>
            <span>{basicConfig.customizeEndTitle}</span>
        </div> : <div style={style}>
        <span>{basicConfig.title}</span>
        <span>{leftTime.days}天</span>
        <span>{leftTime.hours}时</span>
        <span>{leftTime.minutes}分</span>
        <span>{leftTime.seconds}秒</span>
    </div>;
};

const productId__63 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const position__63 = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle__63 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_60879973ac3e34713f69b61629613043.png",
  bgColor: "transparent",
  width: 260,
  height: 60
};
const text__63 = {
  content: "",
  color: "transparent",
  fontSize: 16
};

const BuyButton__63 = ({
  text: text__63,
  btnStyle: btnStyle__63,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = React.createRef();
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  let hasTrack = false;
  useEffect(() => {
    if (popLog) popTrack();

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const purchase = () => {
    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__63.iosId
      };
    } else {
      param = {
        itemId: productId__63.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            }
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const popTrack = () => {
    if (hasTrack) return;
    const pos = buttonRef.current.getBoundingClientRect();

    if (pos.bottom <= window.innerHeight) {
      if (qt.env.inApp) {
        qt.log.event({
          label: 'view',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'view', logData);
      }

      hasTrack = true;
    }
  };

  if (popLog) {
    window.addEventListener('scroll', popTrack);
  }

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__63} onClick={() => purchase()} ref={buttonRef}>{text__63}</div>
  </div>;
};

const EnvController__64 = ({
  id: id,
  children: children,
  config: config
}) => {
  const [display, setDisplay] = useState__64(false);
  const {
    version,
    comparison,
    versionEnv,
    env,
    operation,
    versionOperation
  } = config;
  useEffect(() => {
    const envDisplay = env === 'all' ? operation === 'allow' : operation === 'allow' ? qt.env[env] : !qt.env[env];
    if (!qt.env.inApp || !version) return setDisplay(envDisplay);
    qt.compareAppVersion(version).then(comparisons => {
      const versionDisplay = versionOperation === 'allow' ? comparisons[comparison] : !comparisons[comparison];
      const isMatched = qt.env[versionEnv];
      if (versionEnv !== 'all' && !isMatched) return setDisplay(envDisplay);
      setDisplay(envDisplay && versionDisplay);
    });
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const TimeController__65 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__65(isDisplay);
  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const groupType__66 = "onlyAutoRenew";

const MemberGroup__66 = ({ ...contents
}) => {
  const [group, setGroup] = useState__66();
  const [isLoading, setIsLoading] = useState__66(true);
  const baseUrl = `https://webapi.qingting.fm`;
  useEffect__66(() => {
    if (groupCache !== undefined) return;
    let userId = '',
        deviceId = '',
        token = '';
    qt.getUserId({
      realNameUserOnly: true
    }).then(id => {
      if (id) {
        userId = id;

        if (qt.env.inApp) {
          return Promise.all([qt.getDevice(), qt.getAccessToken()]);
        }
      } else {
        setGroup(1);
        groupCache = 1;
        setIsLoading(false);
      }

      return Promise.resolve();
    }).then(res => {
      if (res) {
        deviceId = res[0].deviceId;
        token = res[1];
      }

      return axios.get(baseUrl + '/material/frontend/423/check-user-benefit', {
        params: {
          user_id: userId,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      });
    }).then(data => {
      if (data && data.data && data.data.data && data.data.data.in_autorenew) {
        setGroup(0);
        groupCache = 0;
      } else {
        setGroup(1);
        groupCache = 1;
      }

      setIsLoading(false);
    });
  }, []);
  return <div>
    {!contents || !contents.children || contents.children.length === 0 ? <div>请添加子组件</div> : groupType__66 === 'normal' ? contents.children.length >= 2 ? !isLoading ? group === 0 ? contents.children[0] : contents.children[1] : null : <div>子组件至少两个</div> : groupType__66 === 'onlyAutoRenew' ? group === 0 ? contents.children : null : groupType__66 === 'onlyNoAutoRenew' ? group === 1 ? contents.children : null : null}
  </div>;
};

const productId__71 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const position__71 = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle__71 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_0e21e8f1c0c55dd5ae1a45af1619ddf6.png",
  bgColor: "transparent",
  width: 260,
  height: 60
};
const text__71 = {
  content: "",
  color: "transparent",
  fontSize: 16
};

const BuyButton__71 = ({
  text: text__71,
  btnStyle: btnStyle__71,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = React.createRef();
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  let hasTrack = false;
  useEffect(() => {
    if (popLog) popTrack();

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const purchase = () => {
    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__71.iosId
      };
    } else {
      param = {
        itemId: productId__71.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            }
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const popTrack = () => {
    if (hasTrack) return;
    const pos = buttonRef.current.getBoundingClientRect();

    if (pos.bottom <= window.innerHeight) {
      if (qt.env.inApp) {
        qt.log.event({
          label: 'view',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'view', logData);
      }

      hasTrack = true;
    }
  };

  if (popLog) {
    window.addEventListener('scroll', popTrack);
  }

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__71} onClick={() => purchase()} ref={buttonRef}>{text__71}</div>
  </div>;
};

const TimeController__72 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__72(isDisplay);
  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const MemberGroup__73 = ({ ...contents
}) => {
  const [group, setGroup] = useState__73();
  const [isLoading, setIsLoading] = useState__73(true);
  const baseUrl = `https://webapi.qingting.fm`;
  useEffect__73(() => {
    if (groupCache !== undefined) return;
    let userId = '',
        deviceId = '',
        token = '';
    qt.getUserId({
      realNameUserOnly: true
    }).then(id => {
      if (id) {
        userId = id;

        if (qt.env.inApp) {
          return Promise.all([qt.getDevice(), qt.getAccessToken()]);
        }
      } else {
        setGroup(1);
        groupCache = 1;
        setIsLoading(false);
      }

      return Promise.resolve();
    }).then(res => {
      if (res) {
        deviceId = res[0].deviceId;
        token = res[1];
      }

      return axios.get(baseUrl + '/material/frontend/423/check-user-benefit', {
        params: {
          user_id: userId,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      });
    }).then(data => {
      if (data && data.data && data.data.data && data.data.data.in_autorenew) {
        setGroup(0);
        groupCache = 0;
      } else {
        setGroup(1);
        groupCache = 1;
      }

      setIsLoading(false);
    });
  }, []);
  return <div>
    {!contents || !contents.children || contents.children.length === 0 ? <div>请添加子组件</div> : groupType === 'normal' ? contents.children.length >= 2 ? !isLoading ? group === 0 ? contents.children[0] : contents.children[1] : null : <div>子组件至少两个</div> : groupType === 'onlyAutoRenew' ? group === 0 ? contents.children : null : groupType === 'onlyNoAutoRenew' ? group === 1 ? contents.children : null : null}
  </div>;
};

const productId__77 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const unit__77 = "rem";
const position__77 = {
  top: "",
  left: "",
  right: "",
  bottom: ""
};
const btnStyle__77 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_4cdd72a2b816614f47bbbf1ee9dd6084.png",
  bgColor: "transparent",
  width: 2,
  height: 0.7
};
const text__77 = {
  content: "",
  color: "transparent",
  fontSize: 16
};

const BuyButton__77 = ({
  text: text__77,
  btnStyle: btnStyle__77,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = React.createRef();
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  let hasTrack = false;
  useEffect(() => {
    if (popLog) popTrack();

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const purchase = () => {
    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__77.iosId
      };
    } else {
      param = {
        itemId: productId__77.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            }
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const popTrack = () => {
    if (hasTrack) return;
    const pos = buttonRef.current.getBoundingClientRect();

    if (pos.bottom <= window.innerHeight) {
      if (qt.env.inApp) {
        qt.log.event({
          label: 'view',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'view', logData);
      }

      hasTrack = true;
    }
  };

  if (popLog) {
    window.addEventListener('scroll', popTrack);
  }

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__77} onClick={() => purchase()} ref={buttonRef}>{text__77}</div>
  </div>;
};

const TimeController__78 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__78(isDisplay);
  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
  type: 'live'
}, null);
window.qtWebLog = qtWebLog;
qtWebLog.push('_setAccount', 'MobileSite');

const MemberDraw = ({
  children: children,
  activity_id: activity_id,
  canSetShare: canSetShare,
  shareAddChance: shareAddChance,
  pageTitleCanModify: pageTitleCanModify,
  showTop: showTop,
  showBottom: showBottom,
  serviceUrl: serviceUrl,
  env: env,
  defaultStyle: defaultStyle,
  customeStyle: customeStyle,
  locationStyle: locationStyle,
  threeParty: threeParty,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId
}) => {
  // == 将请求的 url 地址挂载到 window
  window.__SERVICE_URL = serviceUrl;
  return <div id={id}>
            <Index activity_id={activity_id} canSetShare={canSetShare} shareAddChance={shareAddChance} pageTitleCanModify={pageTitleCanModify} showTop={showTop} showBottom={showBottom} env={env} defaultStyle={defaultStyle} customeStyle={customeStyle} locationStyle={locationStyle} threeParty={threeParty} logData={{
      topic_id: window.__BUILDER_PAGE_ID,
      nodeId,
      nodeType,
      id
    }}>
                {children}
            </Index>
        </div>;
};

const scrollAnimation = (currentY, targetY) => {
  const needScrollTop = targetY - currentY;
  let _currentY = currentY;
  const unit = 3; // 滑动单位

  const handle = () => {
    const dist = Math.ceil(needScrollTop / unit);
    _currentY += dist;
    window.scrollTo(_currentY, currentY);

    if (needScrollTop > unit || needScrollTop < -unit) {
      scrollAnimation(_currentY, targetY);
    } else {
      window.scrollTo(_currentY, targetY);
    }
  };

  if (requestAnimationFrame) {
    requestAnimationFrame(handle);
  } else {
    setTimeout(handle, 1);
  }
};

const parseQuery = query => {
  query = query.split('?').pop();
  const queryArr = query ? query.split('&') : [];
  let params = {};

  for (let i = 0, n = queryArr.length; i < n; i++) {
    let arr = queryArr[i].split('=');

    if (arr.length > 0) {
      let key = decodeURIComponent(arr.shift());
      let value = decodeURIComponent(arr.join('=')); // 参数如果带=，在这里加上去

      params[key] = value;
    }
  }

  return params;
};

const TabNavsContainer = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  children: children,
  navs: navs,
  config: config
}) => {
  const defaultTabNavIndex = useMemo(() => {
    const configDefaultIndex = navs.findIndex(nav => nav.default);
    const params = parseQuery(window.location.search);
    const {
      tabNavsId,
      tabNavsIndex
    } = params;
    if (tabNavsId && tabNavsId !== id) return configDefaultIndex;
    const index = tabNavsIndex ? parseInt(tabNavsIndex) : -1;
    return index >= 0 ? index : configDefaultIndex;
  }, []);
  const [currTabNavIndex, setCurrTabNavIndex] = useState__82(defaultTabNavIndex > -1 ? defaultTabNavIndex : 0);
  const [offsetTop, setOffsetTop] = useState__82();
  const [fixed, setFixed] = useState__82(false);
  const navsRef = useRef__82();
  const {
    showTitle,
    open: openFixed = false,
    top: fixedTop = 0,
    inactive,
    active,
    openCache,
    openLog
  } = config; // == 日志发送

  const sendLogRef = useRef__82(tabIndex => {
    const pageId = window.__BUILDER_PAGE_ID;
    const logData = {
      topic_id: pageId,
      identifier: nodeId,
      pos: {
        type: nodeType,
        name: id,
        sub: pageId,
        tab: tabIndex
      }
    };

    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }
  }); // == 标签导航通用样式

  const navStyle = {
    navBar: {
      fontSize: config.fontSize,
      color: config.color,
      height: config.height
    },
    navItem: {
      height: config.itemHeight,
      marginRight: config.marginRight
    },
    activeItem: {},
    activeText: {
      fontSize: active.fontSize,
      color: active.color,
      fontWeight: active.fontWeight
    },
    activeLine: active.line,
    content: config.content
  }; // == 背景样式

  navStyle.navBar.background = config.backgroundImage ? `url(${config.backgroundImage}) center center / contain repeat-x ${config.backgroundColor || ''}` : config.backgroundColor;
  navStyle.navItem.background = inactive.backgroundImage ? `url(${inactive.backgroundImage}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : inactive.backgroundColor;
  navStyle.activeItem.background = active.backgroundImage ? `url(${active.backgroundImage}) center center / contain no-repeat ${active.backgroundColor || ''}` : active.backgroundColor;

  const getCurrScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  }; // == 初始化偏移距离


  useEffect(() => {
    const loadListener = () => {
      if (!navsRef.current) return;
      const top = navsRef.current.getBoundingClientRect().top - fixedTop;
      const offsetTop = getCurrScrollTop() + top;
      console.log('navs offsetTop-->', offsetTop);
      setOffsetTop(offsetTop);
    };

    window.addEventListener('load', loadListener);
    return () => {
      window.removeEventListener('load', loadListener);
    };
  }, []);

  const handleScroll = () => {
    const scrollTop = getCurrScrollTop();

    if (scrollTop >= offsetTop) {
      if (!fixed) setFixed(true);
    } else {
      if (fixed) setFixed(false);
    }
  }; // == 监听滚动并吸顶


  useEffect(() => {
    if (!(offsetTop >= 0)) return;

    if (openFixed) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop, fixed]); // == 监听导航变化并发送日志

  useEffect(() => {
    navs[currTabNavIndex]._activeCache = true; // 缓存触发标记

    if (!openLog) return;
    sendLogRef.current(currTabNavIndex);
  }, [currTabNavIndex]); // == 导航点击事件处理

  const navHandle = (nav, navIndex) => {
    const isActive = navIndex === currTabNavIndex;
    if (isActive) return;
    if (nav.link) return window.location.href = nav.link;
    setCurrTabNavIndex(navIndex); // == 平滑滚动至固定位置

    if (openFixed && fixed) {
      const scrollTop = getCurrScrollTop();
      if (scrollTop > offsetTop) scrollAnimation(scrollTop, offsetTop);
    }
  };

  const {
    navBar,
    navItem,
    activeItem,
    activeText,
    activeLine
  } = navStyle;
  const activeLineTop = activeLine.paddingBottom + activeLine.borderBottomWidth;
  const components = children ? children.length ? children : [children] : [];
  return <div className="relative scroll-y" style={fixed ? {
    paddingTop: navBar.height
  } : {}}>
      <div ref={navsRef} className={`wd-100${fixed ? ' fixed z-index-5' : ''}`} style={fixed ? {
      top: fixedTop
    } : {}}>
        <div className="flex flex-between items-center" style={{ ...navBar,
        marginRight: -navItem.marginRight
      }}>
          {navs.map((nav, navIndex) => {
          const isActive = navIndex === currTabNavIndex;
          const inactiveBackground = nav.image.inactive ? `url(${nav.image.inactive}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : navStyle.navItem.background;
          const activeBackground = nav.image.active ? `url(${nav.image.active}) center center / contain no-repeat ${active.backgroundColor || ''}` : navStyle.activeItem.background;
          const itemStyle = { ...navItem,
            ...(isActive ? activeItem : {})
          };
          const textStyle = isActive ? { ...activeText,
            ...activeLine,
            paddingTop: activeLineTop
          } : {};
          itemStyle.background = isActive ? activeBackground : inactiveBackground;
          return <a key={navIndex} className="flex flex-center items-center wd-100" style={itemStyle} onClick={() => {
            navHandle(nav, navIndex);
          }}>
                {showTitle ? <div className="nowrap" style={textStyle}>{nav.title}</div> : null}
              </a>;
        })}
        </div>
      </div>
      {components.length ? openCache ? <div className="relative">
            {components.map((child, childIndex) => {
        const isActiveCache = navs[childIndex]._activeCache;
        const isActive = childIndex === currTabNavIndex;
        return isActiveCache ? <div key={childIndex} className={`${isActive ? '' : 'hide'}`}>{child}</div> : isActive ? <div key={childIndex}>{child}</div> : null;
      })}
          </div> : <div className="relative">
          {components.map((child, childIndex) => {
        return childIndex === currTabNavIndex ? child : null;
      })}
        </div> : <div className="text-center mv-3 f14">请添加导航子组件</div>}
    </div>;
};

const isDynamicChannel = false;
const channel_ids = "271526,231968,232855,226427,266743";
const channelsData = [{
  link: {
    content: "271526"
  },
  imgUrl: "http://pic.qingting.fm/channel/2019/04/10/827ffab384cd4477bcbabca6a5b39efc.jpg!200",
  title: "晓年鉴",
  recWords: "高晓松：知名音乐人、词曲创作者、制作人、导演\n你将获得在；1、1500分钟历历在目的穿越之旅；2、50年的时代精彩记忆；3、50岁后回望半生高晓松式经验；4、横跨文娱政经、贯通中西世界的知识盛宴；5、和历史和时空和人生真正的共振；6、52期特别年代节目——《请回答》系列,邀请相关年份事件的名人大咖在场畅聊,拓展更多话题,透露当年更多细节,全面呈现当时的社会全貌。\n\n\n每周三晚上更新",
  originPrice: 200,
  nowPrice: 200,
  playCnt: "7871.1万"
}, {
  link: {
    content: "231968"
  },
  imgUrl: "http://pic.qingting.fm/channel/2019/12/05/4255e9464f7332e71998efbe9e1c6389.jpg!200",
  title: "老梁的四大名著情商课",
  recWords: "四大名著你真的读懂了吗？老梁带你重溯经典，从草莽到贵族，从神魔斗争到人世战乱，借古喻今，教你如何提高情商，如何在当下处世，才能立于不败之地。\n\n\n\n主播介绍\n梁宏达：著名媒体人，时事评论家，脱口秀超级明星\n课程大纲\n职场困惑：领导都喜欢有人拍马屁,怎么样不用拍？\n人际困惑：跟朋友聚会,其他人有说有笑,我插不进话,我说话的时候,没人搭理我？\n感情困惑：情场的竞争无可避免,如何用情商打败情敌?\n你将获得\n学会中国式的人情世故，知进退，善应对。收获打通人脉经络的终极心法。\n\n老梁粉丝都已入群，你还不来？搜索添加微信号“qingtingtony”，备注“老梁粉丝”，Tony老师拉你进群，跟全国梁粉交流互动，更有惊喜福利不定时放送！",
  originPrice: 199,
  nowPrice: 199,
  playCnt: "2.6亿"
}, {
  link: {
    content: "232855"
  },
  imgUrl: "http://pic.qingting.fm/channel/2019/01/22/06c94b4fcd93c70c98d68b7855a22fcb.jpg!200",
  title: "局座讲风云人物",
  recWords: "这一次，局座以自身学识和阅历为我们遴选了古今中外著名的风云人物。带我们走进这些风云人物波澜壮阔的一生，分析他们的成败得失，完善自己的认知和情商。\n主播介绍\n张召忠：中国军事理论家、评论家；中国海军少将；海带雾霾战理论奠基人\n课程大纲\n三大战略因果律威慑力量之一,保密级别极高,现任局长为局座张召忠。当今世界形势越来越复杂,局座特组建战忽局视野拓展营,从政商军领域出发,以人物为线索,抽丝剥茧,理清时事与局势,为你一举荡平视野障碍,突破思维局限。\n你将获得\n1、战略角度思考问题，全新视野高度\n2、了解世界最新局势及风云人物最新动态\n3、提升知识储备，展现个人魅力",
  originPrice: 199,
  nowPrice: 199,
  playCnt: "3834.9万"
}, {
  link: {
    content: "226427"
  },
  imgUrl: "http://pic.qingting.fm/channel/2017/11/16/fbb2517de0b5b9eb485631ca3bd17444.jpg!200",
  title: "蒋勋细说红楼梦青春版",
  recWords: "【关注公众号：蒋勋（ID：jiangxunfm），获取更多蒋勋独家内容】\n\n美学大师蒋勋，再度带你漫游大观园。凝视青春的叛逆与流浪，反思现代社会的幸福真义。",
  originPrice: 199,
  nowPrice: 139.3,
  playCnt: "1150.1万"
}, {
  link: {
    content: "266743"
  },
  imgUrl: "http://pic.qingting.fm/channel/2020/01/16/bc4cdececfe56f37291a99adf0d0e301.jpg!200",
  title: "梁文道：闻道而来【全集】",
  recWords: "1.4亿人都在听的梁文道独家精神私货。《梁文道：闻道而来》由梁文道与看理想团队共同打造，品鉴万象，解读大千世界；百无禁忌，讲透广阔人生，为你提供了解世界及自己的另一种视角。不是所有的道理都能帮你过好这一生，你值得在庸常生活中，听更具品质的极致观点——《梁文道：闻道而来》已加入会员专享，开通畅听全集。",
  originPrice: "",
  nowPrice: "",
  playCnt: "1.4亿"
}];
const iconUrl = "";
const showType = "list";
const showDynamicData = {
  oriPrice: false,
  playCount: true
};
const nowPriceType = "custom";
const customStyle = {
  text: "",
  color: "#fff",
  backgroundColor: "#F5B652",
  backgroundImage: "https://sss.qingting.fm/qt-builder-manage/upload_c5af75e9216833b75c2c22ae58ae6da1.png",
  width: 125,
  height: 28,
  fontSize: 15
};
const showBuy = false;
const listStyle = {
  backgroundColor: "#3d095a",
  titleColor: "#ffffff",
  descColor: "#b3a8bb",
  playCountColor: "#b3a8bb",
  oriPriceColor: "#666",
  nowPriceColor: "#fd5353",
  channelBg: "#030039",
  iconWidth: 0,
  iconHeight: 0
};
let cacheChannels = [];

const ChannelList = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  showType: showType,
  showOriPrice: showOriPrice,
  showPlayCount: showPlayCount,
  showPurchaseBtn: showPurchaseBtn,
  priceType: priceType,
  customStyle: customStyle
}) => {
  const [channels, setChannels] = useState__83([]);
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };

  const getChannels = () => {
    let api = axios.create({
      baseURL: 'https://webapi.qingting.fm'
    });
    api.interceptors.response.use(resp => resp.data);
    api.get(`/activity/nineone/getChannels?ids=${channel_ids}`).then(data => {
      const channels = data.channels;
      const newChannels = channelsData[0].title ? Object.assign(channelsData, channels) : channels;
      setChannels(newChannels);
      cacheChannels = newChannels;
    });
  };

  useEffect__83(() => {
    if (!isDynamicChannel && !showDynamicData.oriPrice && !showDynamicData.playCount) {
      setChannels(channelsData);
      return;
    }

    if (cacheChannels.length > 0) {
      setChannels(cacheChannels);
      return;
    }

    getChannels();
  }, []);

  const openChannel = id => {
    logData.l = {};
    logData.l.content = id;
    logData.l.type = 'Channel';

    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    qt.route.jumpToChannel({
      channelId: id
    });
  };

  const handleImg = url => {
    if (url) {
      return url.replace(/https?:/, '');
    }

    return '';
  };

  const gridStyle = {
    container: {
      flex: showType === 'towColumnGrid' ? '0 0 45%' : '0 0 30%',
      marginTop: '10px',
      position: 'relative',
      background: listStyle.channelBg,
      borderRadius: 4
    },
    img: {
      width: '100%',
      height: showType === 'towColumnGrid' ? '45vw' : '30vw',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    descContainer: {
      height: 42,
      position: 'relative'
    },
    title: {
      fontSize: '14px',
      color: listStyle.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      padding: '0 4px',
      width: window.innerWidth * 0.3 - customStyle.width
    },
    priceContainer: {
      display: 'flex',
      padding: '0 4px 4px',
      alignItems: 'baseline',
      width: window.innerWidth * 0.3 - customStyle.width
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through',
      marginLeft: 2
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: 15,
      width: 40,
      textAlign: 'center',
      margin: '0 4px 4px'
    }
  };

  const renderGrid = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      position: 'absolute',
      right: 4,
      bottom: 4
    };
    Object.assign(btnStyle, customStyle);
    btnStyle.backgroundImage = `url(${customStyle.backgroundImage})`;
    return <div key={`grid-${i}`} style={gridStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={gridStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={gridStyle.descContainer}>
          <div style={gridStyle.title}>{channel.title}</div>
          <div style={gridStyle.priceContainer}>
            {priceType === 'vip' ? <div style={gridStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={gridStyle.nowPrice}>免费</div> : <div style={gridStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              lineHeight: 1
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={gridStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle.text}</div> : null}
        </div>
        {showPurchaseBtn ? <div style={gridStyle.buyBtn}>购买</div> : null}
      </div>;
  };

  const listDisplayStyle = {
    container: {
      paddingTop: '10px',
      paddingBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      width: '100%'
    },
    ctnBorder: {
      borderBottom: '1px solid rgba(255, 255, 255, .3)'
    },
    img: {
      display: 'block',
      flex: '0 0 auto',
      width: '90px',
      height: '90px',
      borderRadius: 7
    },
    textContainer: {
      marginLeft: '10px',
      lineHeight: 1.3,
      flex: 1
    },
    title: {
      fontSize: '16px',
      fontWeight: 500,
      color: listStyle.titleColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    desc: {
      fontSize: '12px',
      color: listStyle.descColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    playCountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      marginTop: 15,
      justifyContent: 'space-between'
    },
    playCount: {
      fontSize: 12,
      color: listStyle.playCountColor
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      width: 40,
      textAlign: 'center',
      marginTop: 5,
      fontSize: 15
    }
  };

  const renderList = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      borderRadius: customStyle.height / 2,
      lineHeight: customStyle.height + 'px',
      textAlign: 'center',
      flex: '0 0 auto'
    };
    Object.assign(btnStyle, customStyle);
    btnStyle.backgroundImage = `url(${customStyle.backgroundImage})`;
    return <div key={`list-${i}`} style={i !== channels.length - 1 ? Object.assign(listDisplayStyle.ctnBorder, listDisplayStyle.container) : listDisplayStyle.container} onClick={() => openChannel(channel.link.content)}>
        <div style={Object.assign({
        backgroundImage: `url(${handleImg(channel.imgUrl)})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }, listDisplayStyle.img)}>
          <img style={{
          width: listStyle.iconWidth,
          height: listStyle.iconHeight
        }} src={handleImg(iconUrl)} alt=''></img>
        </div>
        <div style={listDisplayStyle.textContainer}>
          <div style={listDisplayStyle.title}>{channel.title}</div>
          <div style={listDisplayStyle.desc}>{channel.recWords}</div>
          <div style={listDisplayStyle.playCountContainer}>
            {showPlayCount ? <div style={listDisplayStyle.playCount}>播放量：{channel.playCnt}</div> : null}
            {priceType === 'custom' ? <div style={btnStyle}>{customStyle.text}</div> : null}
          </div>
          {showOriPrice ? <div style={listDisplayStyle.oriPrice}>原价 {channel.originPrice}</div> : null}
          {priceType === 'custom' ? null : <div style={listDisplayStyle.nowPrice}>{priceType === 'vip' ? '会员免费/88折' : priceType === 'free' ? '免费' : `现价 ${channel.nowPrice}`}</div>}
          {showPurchaseBtn ? <div style={listDisplayStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  const singleLineStyle = {
    container: {
      flex: '0 0 28%',
      margin: '10px 10px 10px 0',
      background: listStyle.channelBg,
      borderRadius: 4,
      overflow: 'hidden'
    },
    img: {
      width: '100%',
      height: 'calc(28vw)',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    textContainer: {
      height: 58,
      padding: '0 5px'
    },
    title: {
      fontSize: '13px',
      height: 14,
      lineHeight: 1.2,
      color: listStyle.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    priceContainer: {
      display: 'flex',
      alignItems: 'baseline',
      width: 0
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle.oriPriceColor,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle.nowPriceColor
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: '13px',
      textAlign: 'center',
      margin: '5px'
    }
  };

  const renderSingleLine = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      margin: '0 auto'
    };
    Object.assign(btnStyle, customStyle);
    btnStyle.backgroundImage = `url(${customStyle.backgroundImage})`;
    return <div key={`single-line-${i}`} style={singleLineStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={singleLineStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={singleLineStyle.textContainer}>
          <div style={singleLineStyle.title}>{channel.title}</div>
          <div style={singleLineStyle.priceContainer}>
            {priceType === 'vip' ? <div style={singleLineStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={singleLineStyle.nowPrice}>免费</div> : <div style={singleLineStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              marginRight: 4
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={singleLineStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle.text}</div> : null}
          {showPurchaseBtn ? <div style={singleLineStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  return <div style={{
    background: listStyle.backgroundColor
  }}>
      {channels && channels.length > 0 && channels[0].title !== '' ? showType === 'singleLine' ? <div style={{
      display: 'flex',
      overflowX: 'auto',
      padding: '0 10px',
      position: 'relative'
    }}>
            {channels.map((channel, i) => renderSingleLine(channel, i))}
          </div> : showType === 'list' ? <div style={{
      margin: '0 10px',
      padding: '10px 0'
    }}>
            {channels.map((channel, i) => renderList(channel, i))}
          </div> : <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden'
    }}>
            {channels.map((channel, i) => renderGrid(channel, i))}
          </div> : null}
    </div>;
};

const channel_ids__84 = "294280,304214,115484,102974,140444,275733,332427,275479,292369,218610";
const channelsData__84 = [{
  link: {
    content: "294280"
  },
  imgUrl: "http://pic.qingting.fm/channel/2020/03/06/040e9453eeac2a53806add0b7c7f90b9.jpg!200",
  title: "斗罗大陆|全网超百亿点击",
  recWords: "网文之王唐家三少最经典玄幻神作！唐门外门弟子唐三，意外穿越到斗罗大陆，一步步修炼武魂，由人成神，最终铲除终极邪恶力量，报杀母之仇，成为大陆最强者！\n\n作者： 唐家三少\n\n旁白：张磊 @三石不够咸\n小舞：周姝 @周姝不做废柴\n小唐三：语歇 @语歇Sailor_Mung\n朱竹清：严浩天 @浩天_欧奈Sama\n唐三：顾然 @奔跑的顾然\n戴沐白：张磊 @三石不够咸\n奥斯卡：王哲@王哲同學Albert\n马红俊：齐明哲@CV稳得高处\n唐昊：林声@CV林声\n大师：王建新@CV尘语\n唐大长老：郭政建\n老村长：狐狸@木木夕难再见木目心\n  冠声文化制作",
  originPrice: 125,
  nowPrice: 125,
  playCnt: "7034.9万"
}, {
  link: {
    content: "304214"
  },
  imgUrl: "http://pic.qingting.fm/channel/2019/06/28/87ab6a5db2086572ac4b44c20e7aa976.jpg!200",
  title: "鬼吹灯后传【周建龙演播】",
  recWords: "鬼吹灯世界，风云再起！中广影音2019开山力作，散仙建龙携手鬼吹灯重磅来袭。",
  originPrice: 66.9,
  nowPrice: 66.9,
  playCnt: "4399.8万"
}, {
  link: {
    content: "115484"
  },
  imgUrl: "http://pic.qingting.fm/channel/2020/03/10/48814cc742643c03f23b1a7cf807ffb5.jpg!200",
  title: "东北往事（1-5）【周建龙演播代表作】",
  recWords: "【蜻蜓fm独家音频，散仙周建龙演播代表作之一！孔二狗执导电影《东北往事之二十年》原著小说！】\n本书是对1986年后20年间世事变迁的一次另类追忆，它以一个陌生但可感触的群体为视角，将富有时代气息的社会变迁融于其中，写的是往事，却又让人不得不想到当下与未来。该书一经出版，就轰动了整个华语世界，引起广泛的评论和赞扬，被成千上万的忠实读者痴迷追读，上市以来，连续98周高居全国各大图书畅销榜，销量已突破百万册。",
  originPrice: 27.4,
  nowPrice: 27.4,
  playCnt: "11.9亿"
}, {
  link: {
    content: "102974"
  },
  imgUrl: "http://pic.qingting.fm/2017/0301/20170301111555740.jpg!200",
  title: "茅山后裔（6部完整版）",
  recWords: "百万销量，中国最好的玄学探秘小说！张国忠、张毅城父子运用茅山道术踏足天下，从驱鬼镇邪到探秘寻奇无所不及，民间冤案、千古谜团将被一一揭开。书中没有刀光剑影的打斗，没有飞檐走壁的神功，这不是一部虚张声势的视觉大片，而是一本真正的茅山道士为主题的小说。\n作者：大力金钢掌。1-4部演播：姚科，5-6部演播：文石！",
  originPrice: 53.8,
  nowPrice: 53.8,
  playCnt: "18.1亿"
}, {
  link: {
    content: "140444"
  },
  imgUrl: "http://pic.qingting.fm/channel/replace/140444.jpg!200",
  title: "权力巅峰",
  recWords: "几十次风云升迁，数千场明争暗斗。",
  originPrice: 313,
  nowPrice: 234.75,
  playCnt: "24.2亿"
}, {
  link: {
    content: "275733"
  },
  imgUrl: "http://pic.qingting.fm/goods/2018/11/29/1c89f9b498dfa9514f61eb02bd623739.jpg!200",
  title: "人类简史",
  recWords: "8小时听完人类发展一万年。以色列新锐历史学家尤瓦尔\xB7赫拉利代表作。第十届文津图书奖获奖图书；\n第三届“水木书榜•清华学生喜爱的十本好书”之一；\n奥巴马、比尔•盖茨、扎克伯格、贾雷德•戴蒙德、罗振宇、陈嘉映等高度赞扬\n以色列新锐历史学家尤瓦尔•赫拉利代表作\n一部宏大的、突破性的人类简史，讲清“我是谁，我从哪里来，又要到哪里去”三大基本问题，理清了影响人类发展的重大脉络\n摒弃“人类中心论”“西方中心论”“民族国家中心论”等传统历史理论框架和写作思路，从全新的视角观察人类的起源和发展。\n打破学科边界，融合多学科多领域知识，在知识日益碎片化的时代，为读者提供统合性知识，讲清楚地球和人类自己的完整故事。",
  originPrice: 34,
  nowPrice: 34,
  playCnt: "504.5万"
}, {
  link: {
    content: "332427"
  },
  imgUrl: "http://pic.qingting.fm/channel/2019/11/20/1464b339ee8c4784c4b80f0b0a8bfb38.jpg!200",
  title: "百年孤独",
  recWords: "《百年孤独》是魔幻现实主义文学的代表作，描写了布恩迪亚家族七代人的传奇故事，以及加勒比海沿岸小镇马孔多的百年兴衰，反映了拉丁美洲一个世纪以来风云变幻的历史。\n\n作品融入神话传说、民间故事、宗教典故等因素，巧妙地糅合了现实与虚幻，展现出一个瑰丽的想象世界，成为20世纪重要的经典文学巨著。\n\n1982年加西亚\xB7马尔克斯获得诺贝尔文学奖，奠定文学大师的地位，很大程度上便是凭借《百年孤独》的巨大影响。\n作者:加西亚\xB7马尔克斯 播者:王明军",
  originPrice: 29.9,
  nowPrice: 29.9,
  playCnt: "31万"
}, {
  link: {
    content: "275479"
  },
  imgUrl: "http://pic.qingting.fm/channel/2018/11/27/76f80dd400ee3e5237123d9fca8a7f72.jpg!200",
  title: "围城",
  recWords: "作者钱锺书，演播晏积瑄、白钢，人民文学出版社诚意出品！",
  originPrice: 27.5,
  nowPrice: 27.5,
  playCnt: "92.1万"
}, {
  link: {
    content: "292369"
  },
  imgUrl: "http://pic.qingting.fm/goods/2019/04/02/17509aaecb357fc3acec95fdf8042299.jpg!200",
  title: "教父三部曲",
  recWords: "载入美国出版史的重磅热销书！《教父》是男人的圣经，是智慧的总和，是一切问题的答案。出版后67周占领《纽约时报》热销书榜单，被译为37种语言，销量突破2000万册。各国读者热血推荐，豆瓣评分高达9.1分。《教父》同名电影获9项奥斯卡提名，夺得3项奥斯卡大奖！【付费精品，每晚10点更新3集】",
  originPrice: 75,
  nowPrice: 75,
  playCnt: "165.7万"
}, {
  link: {
    content: "218610"
  },
  imgUrl: "http://pic.qingting.fm/channel/replace/218610.jpg!200",
  title: "白鹿原（无删减版）",
  recWords: "电视剧白鹿原同名有声小说，作者陈忠实，演播李野墨，欢迎各位收听~\n这是一部渭河平原50年变迁的雄奇史诗，一轴中国农村斑斓多彩，触目惊心的长幅画卷。主人公六娶六丧，神秘的序曲预示着不祥。一个家庭两代子孙，为争夺白鹿原的统治代代争斗不已，上演了一幕幕惊心动魄的话剧：巧取风水地，恶施美人计，孝子为匪，亲翁杀媳，兄弟相煎，情人反目……大革命、日寇入侵、三年内战，白鹿原翻云覆雨，王旗变幻，家仇国恨交错缠结……古老的土地在新生的阵痛中战栗！",
  originPrice: 36,
  nowPrice: 36,
  playCnt: "779.1万"
}];
const showDynamicData__84 = {
  oriPrice: false,
  playCount: true
};
const customStyle__84 = {
  text: "",
  color: "#fff",
  backgroundColor: "#F5B652",
  backgroundImage: "https://sss.qingting.fm/qt-builder-manage/upload_97e06f0e00d4db0c24751621c681916e.png",
  width: 125,
  height: 28,
  fontSize: 15
};
const listStyle__84 = {
  backgroundColor: "#3d095a",
  titleColor: "#ffffff",
  descColor: "#b3a8bb",
  playCountColor: "#b3a8bb",
  oriPriceColor: "#666",
  nowPriceColor: "#fd5353",
  channelBg: "#030039",
  iconWidth: 0,
  iconHeight: 0
};
let cacheChannels__84 = [];

const ChannelList__84 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  showType: showType,
  showOriPrice: showOriPrice,
  showPlayCount: showPlayCount,
  showPurchaseBtn: showPurchaseBtn,
  priceType: priceType,
  customStyle: customStyle__84
}) => {
  const [channels, setChannels] = useState__84([]);
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };

  const getChannels = () => {
    let api = axios.create({
      baseURL: 'https://webapi.qingting.fm'
    });
    api.interceptors.response.use(resp => resp.data);
    api.get(`/activity/nineone/getChannels?ids=${channel_ids__84}`).then(data => {
      const channels = data.channels;
      const newChannels = channelsData__84[0].title ? Object.assign(channelsData__84, channels) : channels;
      setChannels(newChannels);
      cacheChannels__84 = newChannels;
    });
  };

  useEffect__84(() => {
    if (!isDynamicChannel && !showDynamicData__84.oriPrice && !showDynamicData__84.playCount) {
      setChannels(channelsData__84);
      return;
    }

    if (cacheChannels__84.length > 0) {
      setChannels(cacheChannels__84);
      return;
    }

    getChannels();
  }, []);

  const openChannel = id => {
    logData.l = {};
    logData.l.content = id;
    logData.l.type = 'Channel';

    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    qt.route.jumpToChannel({
      channelId: id
    });
  };

  const handleImg = url => {
    if (url) {
      return url.replace(/https?:/, '');
    }

    return '';
  };

  const gridStyle = {
    container: {
      flex: showType === 'towColumnGrid' ? '0 0 45%' : '0 0 30%',
      marginTop: '10px',
      position: 'relative',
      background: listStyle__84.channelBg,
      borderRadius: 4
    },
    img: {
      width: '100%',
      height: showType === 'towColumnGrid' ? '45vw' : '30vw',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    descContainer: {
      height: 42,
      position: 'relative'
    },
    title: {
      fontSize: '14px',
      color: listStyle__84.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      padding: '0 4px',
      width: window.innerWidth * 0.3 - customStyle__84.width
    },
    priceContainer: {
      display: 'flex',
      padding: '0 4px 4px',
      alignItems: 'baseline',
      width: window.innerWidth * 0.3 - customStyle__84.width
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__84.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through',
      marginLeft: 2
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__84.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: 15,
      width: 40,
      textAlign: 'center',
      margin: '0 4px 4px'
    }
  };

  const renderGrid = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      position: 'absolute',
      right: 4,
      bottom: 4
    };
    Object.assign(btnStyle, customStyle__84);
    btnStyle.backgroundImage = `url(${customStyle__84.backgroundImage})`;
    return <div key={`grid-${i}`} style={gridStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={gridStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={gridStyle.descContainer}>
          <div style={gridStyle.title}>{channel.title}</div>
          <div style={gridStyle.priceContainer}>
            {priceType === 'vip' ? <div style={gridStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={gridStyle.nowPrice}>免费</div> : <div style={gridStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              lineHeight: 1
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={gridStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle__84.text}</div> : null}
        </div>
        {showPurchaseBtn ? <div style={gridStyle.buyBtn}>购买</div> : null}
      </div>;
  };

  const listDisplayStyle = {
    container: {
      paddingTop: '10px',
      paddingBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      width: '100%'
    },
    ctnBorder: {
      borderBottom: '1px solid rgba(255, 255, 255, .3)'
    },
    img: {
      display: 'block',
      flex: '0 0 auto',
      width: '90px',
      height: '90px',
      borderRadius: 7
    },
    textContainer: {
      marginLeft: '10px',
      lineHeight: 1.3,
      flex: 1
    },
    title: {
      fontSize: '16px',
      fontWeight: 500,
      color: listStyle__84.titleColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    desc: {
      fontSize: '12px',
      color: listStyle__84.descColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    playCountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      marginTop: 15,
      justifyContent: 'space-between'
    },
    playCount: {
      fontSize: 12,
      color: listStyle__84.playCountColor
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__84.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__84.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      width: 40,
      textAlign: 'center',
      marginTop: 5,
      fontSize: 15
    }
  };

  const renderList = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      borderRadius: customStyle__84.height / 2,
      lineHeight: customStyle__84.height + 'px',
      textAlign: 'center',
      flex: '0 0 auto'
    };
    Object.assign(btnStyle, customStyle__84);
    btnStyle.backgroundImage = `url(${customStyle__84.backgroundImage})`;
    return <div key={`list-${i}`} style={i !== channels.length - 1 ? Object.assign(listDisplayStyle.ctnBorder, listDisplayStyle.container) : listDisplayStyle.container} onClick={() => openChannel(channel.link.content)}>
        <div style={Object.assign({
        backgroundImage: `url(${handleImg(channel.imgUrl)})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }, listDisplayStyle.img)}>
          <img style={{
          width: listStyle__84.iconWidth,
          height: listStyle__84.iconHeight
        }} src={handleImg(iconUrl)} alt=''></img>
        </div>
        <div style={listDisplayStyle.textContainer}>
          <div style={listDisplayStyle.title}>{channel.title}</div>
          <div style={listDisplayStyle.desc}>{channel.recWords}</div>
          <div style={listDisplayStyle.playCountContainer}>
            {showPlayCount ? <div style={listDisplayStyle.playCount}>播放量：{channel.playCnt}</div> : null}
            {priceType === 'custom' ? <div style={btnStyle}>{customStyle__84.text}</div> : null}
          </div>
          {showOriPrice ? <div style={listDisplayStyle.oriPrice}>原价 {channel.originPrice}</div> : null}
          {priceType === 'custom' ? null : <div style={listDisplayStyle.nowPrice}>{priceType === 'vip' ? '会员免费/88折' : priceType === 'free' ? '免费' : `现价 ${channel.nowPrice}`}</div>}
          {showPurchaseBtn ? <div style={listDisplayStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  const singleLineStyle = {
    container: {
      flex: '0 0 28%',
      margin: '10px 10px 10px 0',
      background: listStyle__84.channelBg,
      borderRadius: 4,
      overflow: 'hidden'
    },
    img: {
      width: '100%',
      height: 'calc(28vw)',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    textContainer: {
      height: 58,
      padding: '0 5px'
    },
    title: {
      fontSize: '13px',
      height: 14,
      lineHeight: 1.2,
      color: listStyle__84.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    priceContainer: {
      display: 'flex',
      alignItems: 'baseline',
      width: 0
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__84.oriPriceColor,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__84.nowPriceColor
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: '13px',
      textAlign: 'center',
      margin: '5px'
    }
  };

  const renderSingleLine = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      margin: '0 auto'
    };
    Object.assign(btnStyle, customStyle__84);
    btnStyle.backgroundImage = `url(${customStyle__84.backgroundImage})`;
    return <div key={`single-line-${i}`} style={singleLineStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={singleLineStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={singleLineStyle.textContainer}>
          <div style={singleLineStyle.title}>{channel.title}</div>
          <div style={singleLineStyle.priceContainer}>
            {priceType === 'vip' ? <div style={singleLineStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={singleLineStyle.nowPrice}>免费</div> : <div style={singleLineStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              marginRight: 4
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={singleLineStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle__84.text}</div> : null}
          {showPurchaseBtn ? <div style={singleLineStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  return <div style={{
    background: listStyle__84.backgroundColor
  }}>
      {channels && channels.length > 0 && channels[0].title !== '' ? showType === 'singleLine' ? <div style={{
      display: 'flex',
      overflowX: 'auto',
      padding: '0 10px',
      position: 'relative'
    }}>
            {channels.map((channel, i) => renderSingleLine(channel, i))}
          </div> : showType === 'list' ? <div style={{
      margin: '0 10px',
      padding: '10px 0'
    }}>
            {channels.map((channel, i) => renderList(channel, i))}
          </div> : <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden'
    }}>
            {channels.map((channel, i) => renderGrid(channel, i))}
          </div> : null}
    </div>;
};

const channel_ids__85 = "262788,236126,277972,284275,271080,330902";
const channelsData__85 = [{
  link: {
    content: "262788"
  },
  imgUrl: "http://pic.qingting.fm/channel/2020/03/30/ab7c1b22bac210b72e81fb53a0577bde.jpg!200",
  title: "天天听《小猪佩奇》，宝宝必听的趣味启蒙",
  recWords: "官方授权，耳朵里的《小猪佩奇》《天天听小猪佩奇》包含156集全集正版高品质原声，以每集正版《小猪佩奇》动画原音主题故事+趣味启蒙教育延伸，从孩子的视角出发，用温馨简单的语言、灵动好听的声音、轻松幽默的方式传达给小朋友一些理念和认知：\n认知与启蒙——探索世界开阔眼见\n宽容与情商——良好性格埋下种子\n尊重与公平——再小也是独立个体\n夸奖与责任——成就感中学会担当\n引导与榜样——乐观积极敢于表达 \n陪伴与守护——呵护奇妙的想象力\n\n这只来自英国的小猪佩奇，已经深入到全世界小孩子的心里，成为这些小不点心目中的头号“明星”。在千呼万唤后，风靡全球、红得发紫的《小猪佩奇》动画片，以听故事+趣味启蒙的全新方式登陆蜻蜓FM啦，为每位小朋友大朋友诚意送上暑期最温馨的礼物。",
  originPrice: 99,
  nowPrice: 99,
  playCnt: "1亿"
}, {
  link: {
    content: "236126"
  },
  imgUrl: "http://pic.qingting.fm/channel/2020/02/05/3b0dec3f40bd6aadc3125a6906f403fc.jpg!200",
  title: "《米小圈上学记》四年级",
  recWords: "顽皮可爱的米小圈上四年级了，在这个新学期里他的同桌成了“卧底”！更为神奇的是米小圈竟然收到了一封来自未来的信！信中说了什么呢？米小圈在未来会是什么样子呢？\n\n   广播剧中还有精喜哟，会定期向同学们爆料北猫叔叔的小秘密！你想知道吗？\n\n   全新《米小圈上学记》四年级广播剧，将为同学们揭开谜底。一起来收听吧！",
  originPrice: 69,
  nowPrice: 55.2,
  playCnt: "3823.5万"
}, {
  link: {
    content: "277972"
  },
  imgUrl: "http://pic.qingting.fm/channel/2018/12/30/370d550294a449f3840ef7c0a5c91c49.jpg!200",
  title: "百变马丁原声音频1~5季",
  recWords: "365天，和马丁一起百变！\n本专辑是著名动画片《百变马丁》的原声音频，每一集都是独立的小故事，随便点开一集，听到的都是新鲜和有趣。",
  originPrice: 99,
  nowPrice: 79.2,
  playCnt: "5558.2万"
}, {
  link: {
    content: "284275"
  },
  imgUrl: "http://pic.qingting.fm/goods/2019/02/18/9b3582622bea82e0b6ad18661765b69d.jpg!200",
  title: "有个小孩叫曹操2【小豆包趣事】",
  recWords: "刚入学不久的曹操很快就成了班里的“明星”，什么事儿都少不了他。当然，很多时候，他是和自己的好朋友段小磊一起“行动”的。一个个妙趣横生的小故事，让小读者能够身临其境地感受到，曹操和自己一样，会在经历中成长，在成长中学习。",
  originPrice: 39,
  nowPrice: 31.2,
  playCnt: "385.7万"
}, {
  link: {
    content: "271080"
  },
  imgUrl: "http://pic.qingting.fm/2018/10/23/partner_aeb3600df6a1b88777ef34ca912dc549.png!200",
  title: "帮帮龙出动之恐龙探险队",
  recWords: "来和恐龙成为好朋友吧！\n小朋友们，如果喜欢我们的节目，欢迎关注订阅我们的官方账号哟！\n\n宇宙的星球里面存活着各种各样的生命体，其中M25星球里面存活着大量的已在地球灭绝的恐龙。帮帮龙探险队为了给孩子们带给生命的美妙去往M25星球探险。\n他们通过探险发现恐龙，帮助恐龙，同时也跟恐龙成为好朋友。",
  originPrice: 25,
  nowPrice: 25,
  playCnt: "1496.9万"
}, {
  link: {
    content: "330902"
  },
  imgUrl: "http://pic.qingting.fm/device/68c98253a9154026bbe92cdc2218f006/1572575085597_PIh8oSRhl.jpeg!200",
  title: "超级飞侠第七季",
  recWords: "这一次，超级飞侠迎来了全新升级——新登场的超级基地、超级装备大升级，2位超级飞侠新成员巴奇和雪儿，而控制室也迎来了一位新成员小风。在每一集中，超级飞侠们都会飞往世界各地不同的地方，为小朋友们递送他们所需要的包裹，因此观众们将跟随超级飞侠穿梭于世界各地。同时，本片中还会呈现世界各地的文化特色，如当地的常用语、当地有名的美食、名人趣事以及有趣的风俗习惯等。",
  originPrice: 49,
  nowPrice: 39.2,
  playCnt: "261.6万"
}];
const showDynamicData__85 = {
  oriPrice: false,
  playCount: true
};
const customStyle__85 = {
  text: "",
  color: "#fff",
  backgroundColor: "#F5B652",
  backgroundImage: "https://sss.qingting.fm/qt-builder-manage/upload_9eb526731255624c2e65f6747027933f.png",
  width: 125,
  height: 28,
  fontSize: 15
};
const listStyle__85 = {
  backgroundColor: "#3d095a",
  titleColor: "#ffffff",
  descColor: "#b3a8bb",
  playCountColor: "#b3a8bb",
  oriPriceColor: "#666",
  nowPriceColor: "#fd5353",
  channelBg: "#030039",
  iconWidth: 0,
  iconHeight: 0
};
let cacheChannels__85 = [];

const ChannelList__85 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  showType: showType,
  showOriPrice: showOriPrice,
  showPlayCount: showPlayCount,
  showPurchaseBtn: showPurchaseBtn,
  priceType: priceType,
  customStyle: customStyle__85
}) => {
  const [channels, setChannels] = useState__85([]);
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };

  const getChannels = () => {
    let api = axios.create({
      baseURL: 'https://webapi.qingting.fm'
    });
    api.interceptors.response.use(resp => resp.data);
    api.get(`/activity/nineone/getChannels?ids=${channel_ids__85}`).then(data => {
      const channels = data.channels;
      const newChannels = channelsData__85[0].title ? Object.assign(channelsData__85, channels) : channels;
      setChannels(newChannels);
      cacheChannels__85 = newChannels;
    });
  };

  useEffect__85(() => {
    if (!isDynamicChannel && !showDynamicData__85.oriPrice && !showDynamicData__85.playCount) {
      setChannels(channelsData__85);
      return;
    }

    if (cacheChannels__85.length > 0) {
      setChannels(cacheChannels__85);
      return;
    }

    getChannels();
  }, []);

  const openChannel = id => {
    logData.l = {};
    logData.l.content = id;
    logData.l.type = 'Channel';

    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    qt.route.jumpToChannel({
      channelId: id
    });
  };

  const handleImg = url => {
    if (url) {
      return url.replace(/https?:/, '');
    }

    return '';
  };

  const gridStyle = {
    container: {
      flex: showType === 'towColumnGrid' ? '0 0 45%' : '0 0 30%',
      marginTop: '10px',
      position: 'relative',
      background: listStyle__85.channelBg,
      borderRadius: 4
    },
    img: {
      width: '100%',
      height: showType === 'towColumnGrid' ? '45vw' : '30vw',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    descContainer: {
      height: 42,
      position: 'relative'
    },
    title: {
      fontSize: '14px',
      color: listStyle__85.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      padding: '0 4px',
      width: window.innerWidth * 0.3 - customStyle__85.width
    },
    priceContainer: {
      display: 'flex',
      padding: '0 4px 4px',
      alignItems: 'baseline',
      width: window.innerWidth * 0.3 - customStyle__85.width
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__85.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through',
      marginLeft: 2
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__85.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: 15,
      width: 40,
      textAlign: 'center',
      margin: '0 4px 4px'
    }
  };

  const renderGrid = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      position: 'absolute',
      right: 4,
      bottom: 4
    };
    Object.assign(btnStyle, customStyle__85);
    btnStyle.backgroundImage = `url(${customStyle__85.backgroundImage})`;
    return <div key={`grid-${i}`} style={gridStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={gridStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={gridStyle.descContainer}>
          <div style={gridStyle.title}>{channel.title}</div>
          <div style={gridStyle.priceContainer}>
            {priceType === 'vip' ? <div style={gridStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={gridStyle.nowPrice}>免费</div> : <div style={gridStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              lineHeight: 1
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={gridStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle__85.text}</div> : null}
        </div>
        {showPurchaseBtn ? <div style={gridStyle.buyBtn}>购买</div> : null}
      </div>;
  };

  const listDisplayStyle = {
    container: {
      paddingTop: '10px',
      paddingBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      width: '100%'
    },
    ctnBorder: {
      borderBottom: '1px solid rgba(255, 255, 255, .3)'
    },
    img: {
      display: 'block',
      flex: '0 0 auto',
      width: '90px',
      height: '90px',
      borderRadius: 7
    },
    textContainer: {
      marginLeft: '10px',
      lineHeight: 1.3,
      flex: 1
    },
    title: {
      fontSize: '16px',
      fontWeight: 500,
      color: listStyle__85.titleColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    desc: {
      fontSize: '12px',
      color: listStyle__85.descColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    playCountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      marginTop: 15,
      justifyContent: 'space-between'
    },
    playCount: {
      fontSize: 12,
      color: listStyle__85.playCountColor
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__85.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__85.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      width: 40,
      textAlign: 'center',
      marginTop: 5,
      fontSize: 15
    }
  };

  const renderList = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      borderRadius: customStyle__85.height / 2,
      lineHeight: customStyle__85.height + 'px',
      textAlign: 'center',
      flex: '0 0 auto'
    };
    Object.assign(btnStyle, customStyle__85);
    btnStyle.backgroundImage = `url(${customStyle__85.backgroundImage})`;
    return <div key={`list-${i}`} style={i !== channels.length - 1 ? Object.assign(listDisplayStyle.ctnBorder, listDisplayStyle.container) : listDisplayStyle.container} onClick={() => openChannel(channel.link.content)}>
        <div style={Object.assign({
        backgroundImage: `url(${handleImg(channel.imgUrl)})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }, listDisplayStyle.img)}>
          <img style={{
          width: listStyle__85.iconWidth,
          height: listStyle__85.iconHeight
        }} src={handleImg(iconUrl)} alt=''></img>
        </div>
        <div style={listDisplayStyle.textContainer}>
          <div style={listDisplayStyle.title}>{channel.title}</div>
          <div style={listDisplayStyle.desc}>{channel.recWords}</div>
          <div style={listDisplayStyle.playCountContainer}>
            {showPlayCount ? <div style={listDisplayStyle.playCount}>播放量：{channel.playCnt}</div> : null}
            {priceType === 'custom' ? <div style={btnStyle}>{customStyle__85.text}</div> : null}
          </div>
          {showOriPrice ? <div style={listDisplayStyle.oriPrice}>原价 {channel.originPrice}</div> : null}
          {priceType === 'custom' ? null : <div style={listDisplayStyle.nowPrice}>{priceType === 'vip' ? '会员免费/88折' : priceType === 'free' ? '免费' : `现价 ${channel.nowPrice}`}</div>}
          {showPurchaseBtn ? <div style={listDisplayStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  const singleLineStyle = {
    container: {
      flex: '0 0 28%',
      margin: '10px 10px 10px 0',
      background: listStyle__85.channelBg,
      borderRadius: 4,
      overflow: 'hidden'
    },
    img: {
      width: '100%',
      height: 'calc(28vw)',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    textContainer: {
      height: 58,
      padding: '0 5px'
    },
    title: {
      fontSize: '13px',
      height: 14,
      lineHeight: 1.2,
      color: listStyle__85.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    priceContainer: {
      display: 'flex',
      alignItems: 'baseline',
      width: 0
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__85.oriPriceColor,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__85.nowPriceColor
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: '13px',
      textAlign: 'center',
      margin: '5px'
    }
  };

  const renderSingleLine = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      margin: '0 auto'
    };
    Object.assign(btnStyle, customStyle__85);
    btnStyle.backgroundImage = `url(${customStyle__85.backgroundImage})`;
    return <div key={`single-line-${i}`} style={singleLineStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={singleLineStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={singleLineStyle.textContainer}>
          <div style={singleLineStyle.title}>{channel.title}</div>
          <div style={singleLineStyle.priceContainer}>
            {priceType === 'vip' ? <div style={singleLineStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={singleLineStyle.nowPrice}>免费</div> : <div style={singleLineStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              marginRight: 4
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={singleLineStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle__85.text}</div> : null}
          {showPurchaseBtn ? <div style={singleLineStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  return <div style={{
    background: listStyle__85.backgroundColor
  }}>
      {channels && channels.length > 0 && channels[0].title !== '' ? showType === 'singleLine' ? <div style={{
      display: 'flex',
      overflowX: 'auto',
      padding: '0 10px',
      position: 'relative'
    }}>
            {channels.map((channel, i) => renderSingleLine(channel, i))}
          </div> : showType === 'list' ? <div style={{
      margin: '0 10px',
      padding: '10px 0'
    }}>
            {channels.map((channel, i) => renderList(channel, i))}
          </div> : <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden'
    }}>
            {channels.map((channel, i) => renderGrid(channel, i))}
          </div> : null}
    </div>;
};

const channel_ids__86 = "353163,353161,353158,353160,354234";
const channelsData__86 = [{
  link: {
    content: "353163"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/02/7ce3590f629637e968674e33ae798b02.jpg!200",
  title: "厚婚秘爱：总裁老公超给力",
  recWords: "\"她不过是相个亲，结果直接却被抗去了民政局。她还不想结婚喂！权少，可不可以离婚啊！\n“离婚？可以，先怀个孩子再说。”\n“我不要……” \"",
  originPrice: "",
  nowPrice: "",
  playCnt: "687"
}, {
  link: {
    content: "353161"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/02/43212d0508ac9ab4ab31aa439d4be2cb.jpg!200",
  title: "农家绝世俏医妃",
  recWords: "\"莫天星现代神医家族的嫡传人，刚穿越过来就面对渣男要求换亲的场面。\n跟渣堂姐换亲她一拍胸脯，这个婚我嫁了这个寡妇我当了可是必须写下断亲书。\n看见婆婆坟墓被挖，她大胆子阻止因此惹上残腿战神王爷从此就被某王爷以治腿之名，各种纠缠。\n莫天星沉寂在斗极品，养全家，发家致富奔小康的道路。\"",
  originPrice: 3,
  nowPrice: 3,
  playCnt: "2698"
}, {
  link: {
    content: "353158"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/02/3ce9c3d30116db453f9f90654cac16d4.jpg!200",
  title: "女总裁的超级高手",
  recWords: "他是纵横地下世界的绝世王者，却被家里逼婚，重返都市。\n且看他如何游走万花丛，片叶不沾身。",
  originPrice: "",
  nowPrice: "",
  playCnt: "2244"
}, {
  link: {
    content: "353160"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/02/78eeb2a34b50e5ec07e76714aaaf4c11.jpg!200",
  title: "女总裁的逍遥保镖",
  recWords: "\"不屑天下权势，不恋绝世功勋，战神为总裁妻子归隐都市，只求与家人相守安度余生。\n奈何周遭满目污邪，自己被欺，妻子受辱……既如此，我就用双手粉碎一切。\n人负我，当踩之。世道欺我，当灭之。\"",
  originPrice: "",
  nowPrice: "",
  playCnt: "1359"
}, {
  link: {
    content: "354234"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/09/709c8c5a3d4ac77ed40028f28f6bbf13.jpg!200",
  title: "不灭武尊",
  recWords: "17K名家作品，东方玄幻大作，全网点击破亿！一门被视为垃圾的功法，一个被同门视作废人的修炼狂人，在得到一枚阴阳玉佩之后，一切将彻底改变。\n十倍修炼速度，令古飞一再突破武道极限，千百年来已被人认定的铁律，被古飞一一打破！\n奇迹……古飞不相信奇迹，他相信的只有血和汗，在这个武道已经没落，真正的武道奥义已经失传的腾龙大陆修炼界，且看古飞如何以武逆天，脚踏道术神通，拳打妖魔鬼怪，怀抱红颜绝色，成就不灭武尊！",
  originPrice: 7,
  nowPrice: 7,
  playCnt: "439"
}];
const showDynamicData__86 = {
  oriPrice: false,
  playCount: true
};
const customStyle__86 = {
  text: "",
  color: "#fff",
  backgroundColor: "#F5B652",
  backgroundImage: "https://sss.qingting.fm/qt-builder-manage/upload_e735d19356f2c0f06d9cefda8865ae7d.png",
  width: 125,
  height: 28,
  fontSize: 15
};
const listStyle__86 = {
  backgroundColor: "#3d095a",
  titleColor: "#ffffff",
  descColor: "#b3a8bb",
  playCountColor: "#b3a8bb",
  oriPriceColor: "#666",
  nowPriceColor: "#fd5353",
  channelBg: "#030039",
  iconWidth: 0,
  iconHeight: 0
};
let cacheChannels__86 = [];

const ChannelList__86 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  showType: showType,
  showOriPrice: showOriPrice,
  showPlayCount: showPlayCount,
  showPurchaseBtn: showPurchaseBtn,
  priceType: priceType,
  customStyle: customStyle__86
}) => {
  const [channels, setChannels] = useState__86([]);
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };

  const getChannels = () => {
    let api = axios.create({
      baseURL: 'https://webapi.qingting.fm'
    });
    api.interceptors.response.use(resp => resp.data);
    api.get(`/activity/nineone/getChannels?ids=${channel_ids__86}`).then(data => {
      const channels = data.channels;
      const newChannels = channelsData__86[0].title ? Object.assign(channelsData__86, channels) : channels;
      setChannels(newChannels);
      cacheChannels__86 = newChannels;
    });
  };

  useEffect__86(() => {
    if (!isDynamicChannel && !showDynamicData__86.oriPrice && !showDynamicData__86.playCount) {
      setChannels(channelsData__86);
      return;
    }

    if (cacheChannels__86.length > 0) {
      setChannels(cacheChannels__86);
      return;
    }

    getChannels();
  }, []);

  const openChannel = id => {
    logData.l = {};
    logData.l.content = id;
    logData.l.type = 'Channel';

    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    qt.route.jumpToChannel({
      channelId: id
    });
  };

  const handleImg = url => {
    if (url) {
      return url.replace(/https?:/, '');
    }

    return '';
  };

  const gridStyle = {
    container: {
      flex: showType === 'towColumnGrid' ? '0 0 45%' : '0 0 30%',
      marginTop: '10px',
      position: 'relative',
      background: listStyle__86.channelBg,
      borderRadius: 4
    },
    img: {
      width: '100%',
      height: showType === 'towColumnGrid' ? '45vw' : '30vw',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    descContainer: {
      height: 42,
      position: 'relative'
    },
    title: {
      fontSize: '14px',
      color: listStyle__86.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      padding: '0 4px',
      width: window.innerWidth * 0.3 - customStyle__86.width
    },
    priceContainer: {
      display: 'flex',
      padding: '0 4px 4px',
      alignItems: 'baseline',
      width: window.innerWidth * 0.3 - customStyle__86.width
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__86.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through',
      marginLeft: 2
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__86.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: 15,
      width: 40,
      textAlign: 'center',
      margin: '0 4px 4px'
    }
  };

  const renderGrid = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      position: 'absolute',
      right: 4,
      bottom: 4
    };
    Object.assign(btnStyle, customStyle__86);
    btnStyle.backgroundImage = `url(${customStyle__86.backgroundImage})`;
    return <div key={`grid-${i}`} style={gridStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={gridStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={gridStyle.descContainer}>
          <div style={gridStyle.title}>{channel.title}</div>
          <div style={gridStyle.priceContainer}>
            {priceType === 'vip' ? <div style={gridStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={gridStyle.nowPrice}>免费</div> : <div style={gridStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              lineHeight: 1
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={gridStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle__86.text}</div> : null}
        </div>
        {showPurchaseBtn ? <div style={gridStyle.buyBtn}>购买</div> : null}
      </div>;
  };

  const listDisplayStyle = {
    container: {
      paddingTop: '10px',
      paddingBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      width: '100%'
    },
    ctnBorder: {
      borderBottom: '1px solid rgba(255, 255, 255, .3)'
    },
    img: {
      display: 'block',
      flex: '0 0 auto',
      width: '90px',
      height: '90px',
      borderRadius: 7
    },
    textContainer: {
      marginLeft: '10px',
      lineHeight: 1.3,
      flex: 1
    },
    title: {
      fontSize: '16px',
      fontWeight: 500,
      color: listStyle__86.titleColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    desc: {
      fontSize: '12px',
      color: listStyle__86.descColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    playCountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      marginTop: 15,
      justifyContent: 'space-between'
    },
    playCount: {
      fontSize: 12,
      color: listStyle__86.playCountColor
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__86.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__86.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      width: 40,
      textAlign: 'center',
      marginTop: 5,
      fontSize: 15
    }
  };

  const renderList = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      borderRadius: customStyle__86.height / 2,
      lineHeight: customStyle__86.height + 'px',
      textAlign: 'center',
      flex: '0 0 auto'
    };
    Object.assign(btnStyle, customStyle__86);
    btnStyle.backgroundImage = `url(${customStyle__86.backgroundImage})`;
    return <div key={`list-${i}`} style={i !== channels.length - 1 ? Object.assign(listDisplayStyle.ctnBorder, listDisplayStyle.container) : listDisplayStyle.container} onClick={() => openChannel(channel.link.content)}>
        <div style={Object.assign({
        backgroundImage: `url(${handleImg(channel.imgUrl)})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }, listDisplayStyle.img)}>
          <img style={{
          width: listStyle__86.iconWidth,
          height: listStyle__86.iconHeight
        }} src={handleImg(iconUrl)} alt=''></img>
        </div>
        <div style={listDisplayStyle.textContainer}>
          <div style={listDisplayStyle.title}>{channel.title}</div>
          <div style={listDisplayStyle.desc}>{channel.recWords}</div>
          <div style={listDisplayStyle.playCountContainer}>
            {showPlayCount ? <div style={listDisplayStyle.playCount}>播放量：{channel.playCnt}</div> : null}
            {priceType === 'custom' ? <div style={btnStyle}>{customStyle__86.text}</div> : null}
          </div>
          {showOriPrice ? <div style={listDisplayStyle.oriPrice}>原价 {channel.originPrice}</div> : null}
          {priceType === 'custom' ? null : <div style={listDisplayStyle.nowPrice}>{priceType === 'vip' ? '会员免费/88折' : priceType === 'free' ? '免费' : `现价 ${channel.nowPrice}`}</div>}
          {showPurchaseBtn ? <div style={listDisplayStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  const singleLineStyle = {
    container: {
      flex: '0 0 28%',
      margin: '10px 10px 10px 0',
      background: listStyle__86.channelBg,
      borderRadius: 4,
      overflow: 'hidden'
    },
    img: {
      width: '100%',
      height: 'calc(28vw)',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    textContainer: {
      height: 58,
      padding: '0 5px'
    },
    title: {
      fontSize: '13px',
      height: 14,
      lineHeight: 1.2,
      color: listStyle__86.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    priceContainer: {
      display: 'flex',
      alignItems: 'baseline',
      width: 0
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__86.oriPriceColor,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__86.nowPriceColor
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: '13px',
      textAlign: 'center',
      margin: '5px'
    }
  };

  const renderSingleLine = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      margin: '0 auto'
    };
    Object.assign(btnStyle, customStyle__86);
    btnStyle.backgroundImage = `url(${customStyle__86.backgroundImage})`;
    return <div key={`single-line-${i}`} style={singleLineStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={singleLineStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={singleLineStyle.textContainer}>
          <div style={singleLineStyle.title}>{channel.title}</div>
          <div style={singleLineStyle.priceContainer}>
            {priceType === 'vip' ? <div style={singleLineStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={singleLineStyle.nowPrice}>免费</div> : <div style={singleLineStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              marginRight: 4
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={singleLineStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle__86.text}</div> : null}
          {showPurchaseBtn ? <div style={singleLineStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  return <div style={{
    background: listStyle__86.backgroundColor
  }}>
      {channels && channels.length > 0 && channels[0].title !== '' ? showType === 'singleLine' ? <div style={{
      display: 'flex',
      overflowX: 'auto',
      padding: '0 10px',
      position: 'relative'
    }}>
            {channels.map((channel, i) => renderSingleLine(channel, i))}
          </div> : showType === 'list' ? <div style={{
      margin: '0 10px',
      padding: '10px 0'
    }}>
            {channels.map((channel, i) => renderList(channel, i))}
          </div> : <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden'
    }}>
            {channels.map((channel, i) => renderGrid(channel, i))}
          </div> : null}
    </div>;
};

const channel_ids__87 = "353396,354450,354449,353164,353162";
const channelsData__87 = [{
  link: {
    content: "353396"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/03/06a33732c9d9a246115d69b61bc8d3eb.jpg!200",
  title: "天上掉下个靖王妃【精品多人剧】",
  recWords: "【一句话推荐】\n自家王妃不惯着，难道留给别人来惯？\n\n【内容简介】\n什么鬼？连人带魂穿到古代也就罢了，长了一张跟邻国逃婚公主一模一样的脸就被拉去替婚？背着一袋古董跑路，刚翻上墙就被消失了一个月的准老公亲手逮了回来！所幸找了雷打不倒的靠山撑腰，终于收服了亲王老公的心，以为从此吃香喝辣，却不想卷入了一场惊天大阴谋。“王爷，如果有一天我犯了死罪，你会如何？”“就是负了这天下，本王也要护你一世安好。”\n\n【作者简介】\n西湖边，掌阅知名大神，擅长言情类作品，作品内容丰富多彩，文笔成熟，人物塑造立体。代表作：《为妃作歹》、《豪门亿万宠婚》、《天上掉下个靖王妃》。\n\n【主播简介】\n人和永泰\xB7极声工作室，是北京人和永泰影视文化发展有限公司旗下专门孵化“高颜值声咖”的专业团队，所有声咖，均是有成熟影视作品的影视剧、舞台剧演员。\n\n逍遥公子，声音清朗温润，又富于变化。阳春白雪，不染烟尘的贵族公子；邪魅狂狷，阴狠毒辣的反派高手；风流倜傥，侠骨柔情的翩翩名士……虽不见其人，却活灵活现，如临其境！\n\n惠殿下，演员、主持人，二次元达人；声音可甜、可盐、可攻，可男、可女！\n\n【参演CV】\n总监：戚鑫 孟娇 \n后期：人和永泰-极声工作室 \n领衔演播：惠殿下 逍遥公子 \n联合演播：西夏公子、水灵儿、竹野良平、水玲珑、南宫一鸣",
  originPrice: 1.8,
  nowPrice: 1.8,
  playCnt: "3875"
}, {
  link: {
    content: "354450"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/10/ba1b2f556cbf1fb89f4c4f4de4eb2167.jpg!200",
  title: "道岳独尊（玄幻仙侠）",
  recWords: "浩瀚宇宙，百万世界，三千圣道，时空秘宝，仙秦诸天，远古洞府，英雄无数，少年张岳，奋发而起，奇遇传承，一剑在手，掌万界生死，圣道在心，阅宇宙存亡！改天换地，只为红颜一笑！乾坤独尊，问剑天下英雄！\n作者：雾外江山\n演播：泫夜、叶露薇",
  originPrice: 10,
  nowPrice: 10,
  playCnt: "77"
}, {
  link: {
    content: "354449"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/10/127132b255507d211f9f4be9f1c164f7.jpg!200",
  title: "皇道（精品双播）",
  recWords: "皇道天帝，霸绝乾坤！灭诸神，斩至尊！修最强功法，得最靓女神！神国废墟掠重宝，绝色天香伴君行！穿梭时空，英雄谁属？唯我皇道至尊！\n作者：雾外江山\n演播：延庄、疏桐",
  originPrice: 9,
  nowPrice: 9,
  playCnt: "712"
}, {
  link: {
    content: "353164"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/02/642f61beb20d334f1c82bcba4153870c.jpg!200",
  title: "云少的替身娇妻",
  recWords: "\"母亲重病住院，安瑾年为筹医药费，答应代替胞姐结婚，却不想让他一夜倾心\n他是云天集团的大老板，谁想那一天让他明白了什么叫命中注定。\n“一天是你的男人，一生就是你的男人。”\n“你到哪里，我就追到哪里。哪怕是地狱，我也要跟着你！”\"",
  originPrice: "",
  nowPrice: "",
  playCnt: "612"
}, {
  link: {
    content: "353162"
  },
  imgUrl: "http://pic.qingting.fm/goods/2020/04/02/174d283acae836203b73d8b63cb0d731.jpg!200",
  title: "重生嫡女归来",
  recWords: "\"药侯嫡女半夏，被姐姐跟心爱的太子哥哥谋害至死。\n再次醒来，重生到回都京的前几天。\n她带着上辈子的记忆，撕开姐姐的美人皮，揭穿继母的假菩萨面。\n都京传言说她乡下土包子，她比谁都潮流，说她是个村姑，她比谁都优雅。\n说她不识字，琴棋书画样样精通，说她傻，好吧扮猪吃老虎可懂？\n鄙夷她，不屑她，哎！讨厌的公子哥一个个扑过来，非要跟她生猴子。\n某太子，一脸的醋意：“说，你跟小将军消失一天去哪了？”\n半夏无语：“跟你有关系？”\n“本殿是你的未婚夫。”\n“我有承认？”\n某太子黑沉着一张脸，只蹦出几个字。\n“舍不得杀你，却能灭他。”\n半夏气急吼道：“月北翼别忘了咱俩是仇人。”\n太子翼：“……”\n仇人？ \"",
  originPrice: "",
  nowPrice: "",
  playCnt: "1万"
}];
const showDynamicData__87 = {
  oriPrice: false,
  playCount: true
};
const customStyle__87 = {
  text: "",
  color: "#fff",
  backgroundColor: "#F5B652",
  backgroundImage: "https://sss.qingting.fm/qt-builder-manage/upload_919d3e4a235d8b2ea27c34172097b0a6.png",
  width: 125,
  height: 28,
  fontSize: 15
};
const listStyle__87 = {
  backgroundColor: "#3d095a",
  titleColor: "#ffffff",
  descColor: "#b3a8bb",
  playCountColor: "#b3a8bb",
  oriPriceColor: "#666",
  nowPriceColor: "#fd5353",
  channelBg: "#030039",
  iconWidth: 0,
  iconHeight: 0
};
let cacheChannels__87 = [];

const ChannelList__87 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  showType: showType,
  showOriPrice: showOriPrice,
  showPlayCount: showPlayCount,
  showPurchaseBtn: showPurchaseBtn,
  priceType: priceType,
  customStyle: customStyle__87
}) => {
  const [channels, setChannels] = useState__87([]);
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };

  const getChannels = () => {
    let api = axios.create({
      baseURL: 'https://webapi.qingting.fm'
    });
    api.interceptors.response.use(resp => resp.data);
    api.get(`/activity/nineone/getChannels?ids=${channel_ids__87}`).then(data => {
      const channels = data.channels;
      const newChannels = channelsData__87[0].title ? Object.assign(channelsData__87, channels) : channels;
      setChannels(newChannels);
      cacheChannels__87 = newChannels;
    });
  };

  useEffect__87(() => {
    if (!isDynamicChannel && !showDynamicData__87.oriPrice && !showDynamicData__87.playCount) {
      setChannels(channelsData__87);
      return;
    }

    if (cacheChannels__87.length > 0) {
      setChannels(cacheChannels__87);
      return;
    }

    getChannels();
  }, []);

  const openChannel = id => {
    logData.l = {};
    logData.l.content = id;
    logData.l.type = 'Channel';

    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    qt.route.jumpToChannel({
      channelId: id
    });
  };

  const handleImg = url => {
    if (url) {
      return url.replace(/https?:/, '');
    }

    return '';
  };

  const gridStyle = {
    container: {
      flex: showType === 'towColumnGrid' ? '0 0 45%' : '0 0 30%',
      marginTop: '10px',
      position: 'relative',
      background: listStyle__87.channelBg,
      borderRadius: 4
    },
    img: {
      width: '100%',
      height: showType === 'towColumnGrid' ? '45vw' : '30vw',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    descContainer: {
      height: 42,
      position: 'relative'
    },
    title: {
      fontSize: '14px',
      color: listStyle__87.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      padding: '0 4px',
      width: window.innerWidth * 0.3 - customStyle__87.width
    },
    priceContainer: {
      display: 'flex',
      padding: '0 4px 4px',
      alignItems: 'baseline',
      width: window.innerWidth * 0.3 - customStyle__87.width
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__87.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through',
      marginLeft: 2
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__87.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: 15,
      width: 40,
      textAlign: 'center',
      margin: '0 4px 4px'
    }
  };

  const renderGrid = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      position: 'absolute',
      right: 4,
      bottom: 4
    };
    Object.assign(btnStyle, customStyle__87);
    btnStyle.backgroundImage = `url(${customStyle__87.backgroundImage})`;
    return <div key={`grid-${i}`} style={gridStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={gridStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={gridStyle.descContainer}>
          <div style={gridStyle.title}>{channel.title}</div>
          <div style={gridStyle.priceContainer}>
            {priceType === 'vip' ? <div style={gridStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={gridStyle.nowPrice}>免费</div> : <div style={gridStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              lineHeight: 1
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={gridStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle__87.text}</div> : null}
        </div>
        {showPurchaseBtn ? <div style={gridStyle.buyBtn}>购买</div> : null}
      </div>;
  };

  const listDisplayStyle = {
    container: {
      paddingTop: '10px',
      paddingBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      width: '100%'
    },
    ctnBorder: {
      borderBottom: '1px solid rgba(255, 255, 255, .3)'
    },
    img: {
      display: 'block',
      flex: '0 0 auto',
      width: '90px',
      height: '90px',
      borderRadius: 7
    },
    textContainer: {
      marginLeft: '10px',
      lineHeight: 1.3,
      flex: 1
    },
    title: {
      fontSize: '16px',
      fontWeight: 500,
      color: listStyle__87.titleColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    desc: {
      fontSize: '12px',
      color: listStyle__87.descColor,
      marginBottom: '6px',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    playCountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      marginTop: 15,
      justifyContent: 'space-between'
    },
    playCount: {
      fontSize: 12,
      color: listStyle__87.playCountColor
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__87.oriPriceColor,
      lineHeight: 1.5,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__87.nowPriceColor,
      lineHeight: 1.5
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      width: 40,
      textAlign: 'center',
      marginTop: 5,
      fontSize: 15
    }
  };

  const renderList = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      borderRadius: customStyle__87.height / 2,
      lineHeight: customStyle__87.height + 'px',
      textAlign: 'center',
      flex: '0 0 auto'
    };
    Object.assign(btnStyle, customStyle__87);
    btnStyle.backgroundImage = `url(${customStyle__87.backgroundImage})`;
    return <div key={`list-${i}`} style={i !== channels.length - 1 ? Object.assign(listDisplayStyle.ctnBorder, listDisplayStyle.container) : listDisplayStyle.container} onClick={() => openChannel(channel.link.content)}>
        <div style={Object.assign({
        backgroundImage: `url(${handleImg(channel.imgUrl)})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }, listDisplayStyle.img)}>
          <img style={{
          width: listStyle__87.iconWidth,
          height: listStyle__87.iconHeight
        }} src={handleImg(iconUrl)} alt=''></img>
        </div>
        <div style={listDisplayStyle.textContainer}>
          <div style={listDisplayStyle.title}>{channel.title}</div>
          <div style={listDisplayStyle.desc}>{channel.recWords}</div>
          <div style={listDisplayStyle.playCountContainer}>
            {showPlayCount ? <div style={listDisplayStyle.playCount}>播放量：{channel.playCnt}</div> : null}
            {priceType === 'custom' ? <div style={btnStyle}>{customStyle__87.text}</div> : null}
          </div>
          {showOriPrice ? <div style={listDisplayStyle.oriPrice}>原价 {channel.originPrice}</div> : null}
          {priceType === 'custom' ? null : <div style={listDisplayStyle.nowPrice}>{priceType === 'vip' ? '会员免费/88折' : priceType === 'free' ? '免费' : `现价 ${channel.nowPrice}`}</div>}
          {showPurchaseBtn ? <div style={listDisplayStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  const singleLineStyle = {
    container: {
      flex: '0 0 28%',
      margin: '10px 10px 10px 0',
      background: listStyle__87.channelBg,
      borderRadius: 4,
      overflow: 'hidden'
    },
    img: {
      width: '100%',
      height: 'calc(28vw)',
      display: 'block',
      borderRadius: '4px 4px 0 0'
    },
    textContainer: {
      height: 58,
      padding: '0 5px'
    },
    title: {
      fontSize: '13px',
      height: 14,
      lineHeight: 1.2,
      color: listStyle__87.titleColor,
      marginTop: '5px',
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    },
    priceContainer: {
      display: 'flex',
      alignItems: 'baseline',
      width: 0
    },
    oriPrice: {
      fontSize: '13px',
      color: listStyle__87.oriPriceColor,
      textDecoration: 'line-through'
    },
    nowPrice: {
      fontSize: '13px',
      color: listStyle__87.nowPriceColor
    },
    buyBtn: {
      background: '#fd5353',
      color: '#fff',
      padding: '3px 10px',
      borderRadius: '20px',
      fontSize: '13px',
      textAlign: 'center',
      margin: '5px'
    }
  };

  const renderSingleLine = (channel, i) => {
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      textAlign: 'center',
      margin: '0 auto'
    };
    Object.assign(btnStyle, customStyle__87);
    btnStyle.backgroundImage = `url(${customStyle__87.backgroundImage})`;
    return <div key={`single-line-${i}`} style={singleLineStyle.container} onClick={() => openChannel(channel.link.content)}>
        <img style={singleLineStyle.img} src={handleImg(channel.imgUrl)} alt='' />
        <div style={singleLineStyle.textContainer}>
          <div style={singleLineStyle.title}>{channel.title}</div>
          <div style={singleLineStyle.priceContainer}>
            {priceType === 'vip' ? <div style={singleLineStyle.nowPrice}>会员免费/88折</div> : priceType === 'free' ? <div style={singleLineStyle.nowPrice}>免费</div> : <div style={singleLineStyle.nowPrice}>¥<span style={{
              fontSize: 20,
              fontWeight: 'bold',
              marginRight: 4
            }}>
                {channel.nowPrice}
              </span></div>}
            {showOriPrice ? <div style={singleLineStyle.oriPrice}>¥{channel.originPrice}</div> : null}
          </div>
          {priceType === 'custom' ? <div style={btnStyle}>{customStyle__87.text}</div> : null}
          {showPurchaseBtn ? <div style={singleLineStyle.buyBtn}>购买</div> : null}
        </div>
      </div>;
  };

  return <div style={{
    background: listStyle__87.backgroundColor
  }}>
      {channels && channels.length > 0 && channels[0].title !== '' ? showType === 'singleLine' ? <div style={{
      display: 'flex',
      overflowX: 'auto',
      padding: '0 10px',
      position: 'relative'
    }}>
            {channels.map((channel, i) => renderSingleLine(channel, i))}
          </div> : showType === 'list' ? <div style={{
      margin: '0 10px',
      padding: '10px 0'
    }}>
            {channels.map((channel, i) => renderList(channel, i))}
          </div> : <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden'
    }}>
            {channels.map((channel, i) => renderGrid(channel, i))}
          </div> : null}
    </div>;
};

const TimeController__90 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__90(isDisplay);
  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const EnvController__95 = ({
  id: id,
  children: children,
  config: config
}) => {
  const [display, setDisplay] = useState__95(false);
  const {
    version,
    comparison,
    versionEnv,
    env,
    operation,
    versionOperation
  } = config;
  useEffect(() => {
    const envDisplay = env === 'all' ? operation === 'allow' : operation === 'allow' ? qt.env[env] : !qt.env[env];
    if (!qt.env.inApp || !version) return setDisplay(envDisplay);
    qt.compareAppVersion(version).then(comparisons => {
      const versionDisplay = versionOperation === 'allow' ? comparisons[comparison] : !comparisons[comparison];
      const isMatched = qt.env[versionEnv];
      if (versionEnv !== 'all' && !isMatched) return setDisplay(envDisplay);
      setDisplay(envDisplay && versionDisplay);
    });
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const MemberGroup__96 = ({ ...contents
}) => {
  const [group, setGroup] = useState__96();
  const [isLoading, setIsLoading] = useState__96(true);
  const baseUrl = `https://webapi.qingting.fm`;
  useEffect__96(() => {
    if (groupCache !== undefined) return;
    let userId = '',
        deviceId = '',
        token = '';
    qt.getUserId({
      realNameUserOnly: true
    }).then(id => {
      if (id) {
        userId = id;

        if (qt.env.inApp) {
          return Promise.all([qt.getDevice(), qt.getAccessToken()]);
        }
      } else {
        setGroup(1);
        groupCache = 1;
        setIsLoading(false);
      }

      return Promise.resolve();
    }).then(res => {
      if (res) {
        deviceId = res[0].deviceId;
        token = res[1];
      }

      return axios.get(baseUrl + '/material/frontend/423/check-user-benefit', {
        params: {
          user_id: userId,
          device_id: deviceId,
          access_token: token
        },
        withCredentials: true
      });
    }).then(data => {
      if (data && data.data && data.data.data && data.data.data.in_autorenew) {
        setGroup(0);
        groupCache = 0;
      } else {
        setGroup(1);
        groupCache = 1;
      }

      setIsLoading(false);
    });
  }, []);
  return <div>
    {!contents || !contents.children || contents.children.length === 0 ? <div>请添加子组件</div> : groupType === 'normal' ? contents.children.length >= 2 ? !isLoading ? group === 0 ? contents.children[0] : contents.children[1] : null : <div>子组件至少两个</div> : groupType === 'onlyAutoRenew' ? group === 0 ? contents.children : null : groupType === 'onlyNoAutoRenew' ? group === 1 ? contents.children : null : null}
  </div>;
};

const TimeController__97 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__97(isDisplay);
  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const position__98 = "bottom";
const effects = "scrollUpShow";
const effectParam = {
  scrollUpDisAppear: {
    top: 500
  },
  scrollUpShow: {
    top: 500
  }
};
const customStyle__98 = {
  width: null,
  height: null,
  aspectRatio: "1080:205",
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_28971fbd00c120d05fd67816111c7ee6.png",
  bgColor: "#5D0080",
  top: 100,
  zIndex: 20
};

const FixedBar = ({
  children: children,
  position: position__98,
  customStyle: customStyle__98,
  effects: effects,
  effectParam: effectParam
}) => {
  const fixBar = useRef();
  const [fixStyle, setFixStyle] = useState({});
  useEffect__98(() => {
    const basicFixStyle = {
      position: 'fixed',
      height: 70,
      transition: 'transform 300ms ease-in',
      zIndex: customStyle__98.zIndex
    };
    const positionStyle = {
      topStyle: {
        top: 0,
        width: '100%'
      },
      bottomStyle: {
        bottom: 0,
        width: '100%'
      },
      leftStyle: {
        left: 0,
        top: '60%',
        width: 70
      },
      rightStyle: {
        right: 0,
        top: '60%',
        width: 70
      }
    };
    let widthRadio, heightRadio;

    if (customStyle__98.aspectRatio) {
      const radios = customStyle__98.aspectRatio.split(':');
      widthRadio = Number(radios[0]);
      heightRadio = Number(radios[1]);
    }

    switch (position__98) {
      case 'top':
        Object.assign(basicFixStyle, positionStyle.topStyle, customStyle__98);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'bottom':
        Object.assign(basicFixStyle, positionStyle.bottomStyle, customStyle__98);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'left':
        Object.assign(basicFixStyle, positionStyle.leftStyle, customStyle__98);
        break;

      case 'right':
        Object.assign(basicFixStyle, positionStyle.rightStyle, customStyle__98);
        break;

      default:
        break;
    }

    switch (effects) {
      case 'scrollUpDisAppear':
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          } else {
            fixBar.current.style.transform = '';
          }
        });
        break;

      case 'scrollUpShow':
        basicFixStyle.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = '';
          } else {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          }
        });
        break;

      default:
        break;
    }

    setFixStyle(basicFixStyle);
  }, []);
  return <div style={fixStyle} ref={fixBar}>{children}</div>;
};

const productId__99 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const position__99 = {
  top: 15,
  left: "",
  right: -5,
  bottom: ""
};
const btnStyle__99 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_eb8dd62fc9e68093d7d69be74bfba9e0.png",
  bgColor: "transparent",
  width: 132,
  height: 47
};
const text__99 = {
  content: "",
  color: "transparent",
  fontSize: 16
};

const BuyButton__99 = ({
  text: text__99,
  btnStyle: btnStyle__99,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = React.createRef();
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  let hasTrack = false;
  useEffect(() => {
    if (popLog) popTrack();

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const purchase = () => {
    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__99.iosId
      };
    } else {
      param = {
        itemId: productId__99.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            }
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const popTrack = () => {
    if (hasTrack) return;
    const pos = buttonRef.current.getBoundingClientRect();

    if (pos.bottom <= window.innerHeight) {
      if (qt.env.inApp) {
        qt.log.event({
          label: 'view',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'view', logData);
      }

      hasTrack = true;
    }
  };

  if (popLog) {
    window.addEventListener('scroll', popTrack);
  }

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__99} onClick={() => purchase()} ref={buttonRef}>{text__99}</div>
  </div>;
};

const TimeController__100 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState__100(isDisplay); // == 实时更新开启以及当前时间在结束时间或者开始时间之前才开启

  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const position__101 = "bottom";
const effectParam__101 = {
  scrollUpDisAppear: {
    top: 500
  },
  scrollUpShow: {
    top: 500
  }
};
const customStyle__101 = {
  width: 70,
  height: 70,
  aspectRatio: "1080:205",
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_07e22cc261fdc18a3604ffa6823c883f.png",
  bgColor: "#5D0080",
  top: 100,
  zIndex: 20
};

const FixedBar__101 = ({
  children: children,
  position: position__101,
  customStyle: customStyle__101,
  effects: effects,
  effectParam: effectParam__101
}) => {
  const fixBar = useRef();
  const [fixStyle, setFixStyle] = useState({});
  useEffect__101(() => {
    const basicFixStyle = {
      position: 'fixed',
      height: 70,
      transition: 'transform 300ms ease-in',
      zIndex: customStyle__101.zIndex
    };
    const positionStyle = {
      topStyle: {
        top: 0,
        width: '100%'
      },
      bottomStyle: {
        bottom: 0,
        width: '100%'
      },
      leftStyle: {
        left: 0,
        top: '60%',
        width: 70
      },
      rightStyle: {
        right: 0,
        top: '60%',
        width: 70
      }
    };
    let widthRadio, heightRadio;

    if (customStyle__101.aspectRatio) {
      const radios = customStyle__101.aspectRatio.split(':');
      widthRadio = Number(radios[0]);
      heightRadio = Number(radios[1]);
    }

    switch (position__101) {
      case 'top':
        Object.assign(basicFixStyle, positionStyle.topStyle, customStyle__101);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'bottom':
        Object.assign(basicFixStyle, positionStyle.bottomStyle, customStyle__101);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'left':
        Object.assign(basicFixStyle, positionStyle.leftStyle, customStyle__101);
        break;

      case 'right':
        Object.assign(basicFixStyle, positionStyle.rightStyle, customStyle__101);
        break;

      default:
        break;
    }

    switch (effects) {
      case 'scrollUpDisAppear':
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam__101[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          } else {
            fixBar.current.style.transform = '';
          }
        });
        break;

      case 'scrollUpShow':
        basicFixStyle.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam__101[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = '';
          } else {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          }
        });
        break;

      default:
        break;
    }

    setFixStyle(basicFixStyle);
  }, []);
  return <div style={fixStyle} ref={fixBar}>{children}</div>;
};

const productId__102 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const position__102 = {
  top: 15,
  left: "",
  right: -5,
  bottom: ""
};
const btnStyle__102 = {
  bgImg: "https://sss.qingting.fm/qt-builder-manage/upload_2076724ed8e62cc09ead6b611cf657e2.png",
  bgColor: "transparent",
  width: 132,
  height: 47
};
const text__102 = {
  content: "",
  color: "transparent",
  fontSize: 16
};

const BuyButton__102 = ({
  text: text__102,
  btnStyle: btnStyle__102,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  popLog: popLog
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const buttonRef = React.createRef();
  const logData = {
    topic_id: window.__BUILDER_PAGE_ID,
    identifier: nodeId,
    pos: {
      type: nodeType,
      name: id
    }
  };
  let hasTrack = false;
  useEffect(() => {
    if (popLog) popTrack();

    if (qt.env.inApp) {
      qt.getDevice().then(res => {
        setDeviceId(res.deviceId);
        return qt.getAccessToken();
      }).then(token => setToken(token));
    }
  }, []);

  const purchase = () => {
    if (qt.env.inApp) {
      qt.log.event({
        label: 'click',
        data: logData
      });
    } else {
      qtWebLog.push('_trackEvent', 'click', logData);
    }

    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__102.iosId
      };
    } else {
      param = {
        itemId: productId__102.androidId
      };
    }

    qt.getUserId().then(id => {
      if (id) {
        if (isBenefit) {
          axios.get('https://webapi.qingting.fm/material/frontend/423/check-user-benefit', {
            params: {
              user_id: id,
              device_id: deviceId,
              access_token: token
            }
          }).then(data => {
            if (data && data.data && data.data.data && data.data.data.has_benefit) {
              alert('您已购买过特惠商品！');
              return;
            } else {
              Toast.info({
                content: '调起支付中...',
                duration: 30000
              });
              qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
            }
          });
        } else {
          Toast.info({
            content: '调起支付中...',
            duration: 30000
          });
          qt.purchase(param).then(() => Toast.close()).catch(() => Toast.close());
        }
      } else {
        qt.login();
      }
    });
  };

  const popTrack = () => {
    if (hasTrack) return;
    const pos = buttonRef.current.getBoundingClientRect();

    if (pos.bottom <= window.innerHeight) {
      if (qt.env.inApp) {
        qt.log.event({
          label: 'view',
          data: logData
        });
      } else {
        qtWebLog.push('_trackEvent', 'view', logData);
      }

      hasTrack = true;
    }
  };

  if (popLog) {
    window.addEventListener('scroll', popTrack);
  }

  return <div>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    <div style={btnStyle__102} onClick={() => purchase()} ref={buttonRef}>{text__102}</div>
  </div>;
};

const goTop = isNeedAnimation => {
  if (!isNeedAnimation) {
    scrollAnimation(document.body.scrollTop || document.documentElement.scrollTop, 0);
  } else {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
};

const RenderButton = props => {
  const [show, switchShow] = useState__103(false);
  const {
    basicConfig,
    children,
    imgInfo
  } = props;
  let {
    width,
    height,
    top,
    bottom,
    left,
    right,
    unit,
    distance,
    isNeedAnimation
  } = basicConfig;

  if (unit !== 'px') {
    width = width + unit;
    height = height + unit;
    top = top + unit;
    right = right + unit;
    bottom = bottom + unit;
    left = left + unit;
  }

  const position = basicConfig.position;
  let currentStyle = {
    width,
    height,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    zIndex: basicConfig.zIndex,
    position
  };

  if (position === 'absolute' || position === 'fixed') {
    currentStyle = {
      width,
      height,
      top,
      right,
      bottom,
      left,
      zIndex: basicConfig.zIndex,
      position
    };
  }

  const imgStyle = {
    width,
    height
  };
  useEffect(() => {
    const buttonShow = throttle(() => {
      const shouldShow = document.body.scrollTop > distance || document.documentElement.scrollTop > distance;

      if (shouldShow !== show) {
        switchShow(shouldShow);
      }
    }, 300);
    document.addEventListener('scroll', buttonShow);
    return () => document.removeEventListener('scroll', buttonShow);
  }, [show]);
  return show ? <div style={currentStyle} onClick={() => goTop(isNeedAnimation)}>
            {children ? children : <img style={imgStyle} src={imgInfo.img} alt={"back-to-top"} />}
        </div> : null;
};

export default (({}) => {
  const basicConfig = {
    title: "蜻蜓FM超级会员2周年",
    shareTitle: "蜻蜓FM会员2周年 重磅福利派送中！",
    shareImg: "https://sss.qingting.fm/qt-builder-manage/upload_699b77846e190439e33196f726164f42.jpg",
    shareSubTitle: "年卡全年最低价+送3重福利，会员还能赢iphone，100%中奖哦！",
    shareLink: "https://sss.qingting.fm/topic/423-member/index.html"
  };
  const containerConfig = {
    startTime: null,
    endTime: null,
    bgc: "#700088",
    themeColor: "#333",
    style: {},
    endTitle: "页面已过期~",
    beforeTitle: "活动还未开始，敬请期待~",
    bgimg: "",
    padding: "0 0 130px",
    margin: ""
  };
  const shareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imageUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  };
  const wxShareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imgUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  };

  //微信分享
  if (wxShare.isInWeixin) {
    wxShare.setShareConfig(wxShareConfig);
  }

  const isInApp = qt.env.inApp;

  if (isInApp) {
    window.onPageAppear = async () => {
      await qt.page.setNavbar({
        show: true
      });
    }; //设置页面分享


    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.setWebviewConfig) {
      window.webkit.messageHandlers.setShareInfo.postMessage({
        shareHidden: 0
      });
    } //
    // //app内部的分享


    qt.page.setShare(shareConfig);
  }

  let inIosApp = qt.env.inIosApp;

  if (inIosApp) {
    window.addEventListener('hashchange', function () {
      qt.page.setShare(shareConfig);
    });
  }

  useEffect(() => {
    document.title = basicConfig.title;
    document.body.style.fontSize = '16px';
    document.body.style.background = containerConfig.bgc;
    document.body.style.backgroundImage = containerConfig.bgimg;
    document.body.style.backgroundRepeat = 'repeat';
    document.getElementById('root').minHeight = window.innerHeight;
    qtWebLog.push('_trackEvent', 'enter', {});

    if (inIosApp) {
      return window.removeEventListener('hashchange', () => {});
    }
  }, []);
  const imgInfo = {
    gifImg: "https://sss.qingting.fm/qt-builder-manage/upload_0d77d458eea780d4c43a34b6c166287c.gif",
    loadingImg: "https://sss.qingting.fm/qt-builder-manage/upload_843d34c2370fc236d129bc945ce90c77.jpg",
    errImg: "",
    imgAlt: "gif",
    unit: "px",
    position: "relative",
    display: "block",
    containerWidth: "100%",
    containerHeight: null,
    gifWidth: "100%",
    gifHeight: null,
    loadingWidth: "100%",
    loadingHeight: null,
    errWidth: "",
    errHeight: "",
    borderRadius: "0",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    zIndex: 0
  };
  const imageArchor = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_156c9fa126a7742d61972122a07a1027.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    imageStyle: {
      width: 60,
      height: null
    },
    style: {
      position: "absolute",
      top: 0,
      bottom: null,
      left: 0,
      right: null,
      type: "rem"
    },
    openNewWebview: false
  };
  const basicConfig__3 = {
    position: "absolute",
    coverImg: "https://sss.qingting.fm/qt-builder-manage/upload_d04348388da4508854af8d9da08a8675.png",
    unit: "px",
    coverImgWidth: 42,
    coverImgHeight: null,
    coverImgTop: 40,
    coverImgRight: 0,
    coverImgBottom: null,
    coverImgLeft: null,
    zIndex: "9",
    ruleContent: "一、会员2周年活动时间：\n2020年4月13日-2020年4月26日\n\n二、关于商品特惠抢购：\n1、预热期：2020年4月13日-2020年4月20日期间，在本活动页首次开通或续购价值228元的蜻蜓FM超级会员年卡，即可享98元全年最低优惠价，另送赠品；用户主动领取赠品时，可能会出现少数充值到账延迟现象，会在7个工作日内完成到账。\n\n2、正式期：2020年4月21日-2020年4月23日期间，在本活动页首次开通或续购价值228元的蜻蜓FM超级会员年卡，即可享98元全年最低优惠价，另送赠品，并可参与抽奖(抽奖具体规则见下方)；用户主动领取赠品时，可能会出现少数充值到账延迟现象，会在7个工作日内完成到账。\n\n3、返场期：2020年4月24日-2020年4月26日期间，在本活动页首次开通或续购价值228元的蜻蜓FM超级会员年卡，即可享98元全年最低优惠价，另送赠品；用户主动领取赠品时，可能会出现少数充值到账延迟现象，会在7个工作日内完成到账。\n\n三、关于抽奖规则：\n1、抽奖活动时间：2020年4月21日-2020年4月23日\n2、抽奖机会：抽奖活动期间，凡是当前有效会员，即可在本活动页享有1次抽奖机会；若在2020年4月13日-2020年4月23日期间，额外购买98元超级会员年卡，可新增1次抽奖机会，多买多得。实物奖品将在活动结束后30个工作日内发放。若用户存在刷奖等故意或者恶意违规的行为，一经核实，将取消中奖资格。\n3、按照国家税法有关政策，个人在抽奖活动中抽中实物奖品，活动方需为中奖者缴纳个人所得税。因此在发放实物奖品前，活动方会通过表单收集或者电话形式要求中奖用户提供身份证号。\n4、实物奖品中奖用户，若因个人原因无法联系或无法提供身份证号，则视为自动放弃领奖资格。\n\n四、关于入驻会员：\n1、3大IP专辑入驻时间：2020年4月21日\n2、3大IP专辑入驻会员后，有效会员用户即可享受该专辑免费畅听权益。成为蜻蜓FM超级会员的用户，也将同时获得每月大额优惠券、会员福利社等更多权益。\n\n五、关于赠品：\n因活动阶段不同及赠品方的合作要求，赠品可能发生变动，具体赠品以购买时页面赠送信息为准，请核对后进行购买。\n\n有关本活动的最终解释权归蜻蜓FM所有，如有其它相关问题，也可拨打客服电话400-6992-927进行咨询。",
    ruleContentHeight: 300,
    ruleContentMaxHeight: 300,
    ruleFontSize: 12,
    lineHeight: "2"
  };
  const basicConfig__4 = {
    imgUrl: "https://sss.qingting.fm/qt-builder-manage/upload_20dcdfe3deadde8dc673de256448fa01.png",
    showOutApp: false,
    style: {
      position: "absolute",
      right: 0,
      top: "70px",
      width: "42px",
      height: "auto",
      zIndex: 1
    },
    shareConfig: {
      title: "蜻蜓FM 超级会员2周年礼",
      desc: "年卡仅售￥98，免费送三大影视平台会员！抢购中>>",
      img: "https://sss.qingting.fm/qt-builder-manage/upload_0729eb3aa23d8d9cb37edfe413bbc9f7.jpg",
      link: "https://sss.qingting.fm/topic/423-member/index.html"
    }
  };
  const basicConfig__5 = {
    unit: "px",
    position: "absolute",
    width: 70,
    height: null,
    top: null,
    bottom: 10,
    left: null,
    right: 10,
    zIndex: "10",
    display: "block"
  };
  const videoConfig = {
    videoMp4Url: "https://sss.qingting.fm/topic/423-member/member.mp4",
    videoOggUrl: "",
    videoWebmUrl: "",
    videoPoster: "https://sss.qingting.fm/qt-builder-manage/upload_845772b4d9fb37aeb7b4d6d50553b135.png"
  };
  const timeController = {
    startTime: null,
    endTime: "2020-04-20 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_3ebf000aaba5fa97f23c02db8646c582.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const imageArchor__9 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_37670949c0bd14c2cc74c079260e30ac.png",
    link: "",
    linkInApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    linkOutApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: 0,
      bottom: null,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const imageArchor__10 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_ffb400383ef7c10a3a4aabff01240fd6.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkOutApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: null,
      bottom: 1.6,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const imageArchor__11 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_a8711c1b75d72e28a040a3068fd92dbc.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/76794",
    linkOutApp: "https://lkme.cc/qfD/PUKM0MatO",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: null,
      bottom: 1,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: false
  };
  const textArchor = {
    title: "*购买增加抽奖机会,多买多得.最高抽iPhone11 Pro Max~",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    textStyle: {
      fontSize: 11,
      color: "#e0c18c",
      fontWeight: 400,
      textDecoration: "none",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    positionStyle: {
      position: "absolute",
      top: null,
      bottom: 0.2,
      left: 0.18,
      right: null,
      type: "rem"
    },
    openNewWebview: false
  };
  const textArchor__13 = {
    title: "直达抽奖",
    link: "4b7",
    linkInApp: "",
    linkOutApp: "",
    textStyle: {
      fontSize: 11,
      color: "#e0c18c",
      fontWeight: 400,
      textDecoration: "underline",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    positionStyle: {
      position: "absolute",
      top: null,
      bottom: 0.2,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: false
  };
  const baseLayoutConfig = {
    commonStyle: {
      textAlign: "center",
      height: null,
      overflow: "hidden",
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "absolute",
      type: "rem",
      top: null,
      bottom: 2.4,
      left: 0,
      right: 0
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style = {
    backgroundImage: `url(${btnStyle.bgImg})`,
    backgroundColor: btnStyle.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text.color,
    fontSize: text.fontSize + unit,
    margin: '0 auto',
    width: btnStyle.width + unit,
    height: btnStyle.height + unit,
    lineHeight: btnStyle.height + unit,
    borderRadius: btnStyle.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle = {
    top: position.top + unit,
    left: position.left + unit,
    right: position.right + unit,
    bottom: position.bottom + unit
  };
  const reStyle = {
    marginTop: position.top + unit,
    marginBottom: position.bottom + unit,
    marginLeft: position.left + unit,
    marginRight: position.right + unit
  };
  const envController = {
    env: "all",
    operation: "allow",
    version: "8.6.2",
    comparison: "isGreaterOrEqual",
    versionEnv: "inIosApp",
    versionOperation: "deny"
  };
  const timeController__17 = {
    startTime: "2020-04-21 00:00:00",
    endTime: "2020-04-26 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage__19 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_61d4088cdf437c74caf0d5b8bffe4bee.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__19 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const imageArchor__20 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_ce14ed961afb39a9927c955d6e922771.png",
    link: "",
    linkInApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    linkOutApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: 0,
      bottom: null,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const imageArchor__21 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_37f39bf6a34d2769c773360da2bf1927.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkOutApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: null,
      bottom: 1.4,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const baseLayoutConfig__22 = {
    commonStyle: {
      textAlign: "center",
      height: null,
      overflow: "hidden",
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "absolute",
      type: "rem",
      top: null,
      bottom: 2.4,
      left: 0,
      right: 0
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style__23 = {
    backgroundImage: `url(${btnStyle__23.bgImg})`,
    backgroundColor: btnStyle__23.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__23.color,
    fontSize: text__23.fontSize + unit,
    margin: '0 auto',
    width: btnStyle__23.width + unit,
    height: btnStyle__23.height + unit,
    lineHeight: btnStyle__23.height + unit,
    borderRadius: btnStyle__23.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__23 = {
    top: position__23.top + unit,
    left: position__23.left + unit,
    right: position__23.right + unit,
    bottom: position__23.bottom + unit
  };
  const reStyle__23 = {
    marginTop: position__23.top + unit,
    marginBottom: position__23.bottom + unit,
    marginLeft: position__23.left + unit,
    marginRight: position__23.right + unit
  };
  const timeController__24 = {
    startTime: "2020-04-27 00:00:00",
    endTime: "2020-04-30 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage__26 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_fcd5dee093e5e5d34e9a6a1d751eebb5.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__26 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const imageArchor__27 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_98546486466956658f8309465d920640.png",
    link: "",
    linkInApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    linkOutApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    imageStyle: {
      width: 50,
      height: null
    },
    style: {
      position: "absolute",
      top: 0,
      bottom: null,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const baseLayoutConfig__28 = {
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "absolute",
      type: "rem",
      top: 0.7,
      bottom: null,
      left: null,
      right: 0.3
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style__29 = {
    backgroundImage: `url(${btnStyle__29.bgImg})`,
    backgroundColor: btnStyle__29.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__29.color,
    fontSize: text__29.fontSize + unit__29,
    margin: '0 auto',
    width: btnStyle__29.width + unit__29,
    height: btnStyle__29.height + unit__29,
    lineHeight: btnStyle__29.height + unit__29,
    borderRadius: btnStyle__29.height / 2 + unit__29,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__29 = {
    top: position__29.top + unit__29,
    left: position__29.left + unit__29,
    right: position__29.right + unit__29,
    bottom: position__29.bottom + unit__29
  };
  const reStyle__29 = {
    marginTop: position__29.top + unit__29,
    marginBottom: position__29.bottom + unit__29,
    marginLeft: position__29.left + unit__29,
    marginRight: position__29.right + unit__29
  };
  const baseLayoutConfig__30 = {
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "https://sss.qingting.fm/qt-builder-manage/upload_f0bc1a9f3c0ba2a42681fb9bda8c2020.jpg",
        repeat: "no-repeat",
        size: "cover"
      }
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: 50,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const singleImage__31 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_643266085295b0bdd603970a85417af4.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__31 = {
    marginTop: -20,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const swiperType = "scale";
  const swiperConfig = {
    swiper: {
      loop: true,
      autoplay: true,
      delay: 3000,
      centeredSlides: true,
      slidesPerView: 1.2,
      spaceBetween: -60,
      direction: "horizontal",
      height: null
    },
    style: {
      height: null
    }
  };
  const singleImage__33 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_c1d3e2aaf4cf59e56c013242cc0e6b9e.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/newTopic/index.html?newTopicId=5e9847184954e90840840bf8&partner=topic_5e9847184954e90840840bf8",
    linkOutApp: "https://sss.qingting.fm/newTopic/index.html?newTopicId=5e9847184954e90840840bf8&partner=topic_5e9847184954e90840840bf8",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: true,
    openNewWebview: true
  };
  const imageContainerStyle__33 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const singleImage__34 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_d144b1706c5ad8102456d82063518530.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/newTopic/index.html?newTopicId=5e9849d2a895df0830cb2c80&partner=topic_5e9849d2a895df0830cb2c80",
    linkOutApp: "https://sss.qingting.fm/newTopic/index.html?newTopicId=5e9849d2a895df0830cb2c80&partner=topic_5e9849d2a895df0830cb2c80",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: true,
    openNewWebview: true
  };
  const imageContainerStyle__34 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const singleImage__35 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_4fa3197027c4f228be692be131db3183.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/newTopic/index.html?newTopicId=5e9942354954e90840840bf9&partner=topic_5e9942354954e90840840bf9",
    linkOutApp: "https://sss.qingting.fm/newTopic/index.html?newTopicId=5e9942354954e90840840bf9&partner=topic_5e9942354954e90840840bf9",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: true,
    openNewWebview: true
  };
  const imageContainerStyle__35 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const timeController__36 = {
    startTime: "2020-04-24 00:00:00",
    endTime: "2020-04-26 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage__37 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1609fa4417576d4a53ef65f65023056f.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__37 = {
    marginTop: 40,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const singleImage__38 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_4a1fc41c9a98e40f953a32f485d6d087.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__38 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const timeController__39 = {
    startTime: "2020-04-24 00:00:00",
    endTime: "2020-04-26 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage__40 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_d6244a0ac96657f7b0e6a71e81206a95.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__40 = {
    marginTop: 40,
    marginBottom: 10,
    marginLeft: null,
    marginRight: null
  };
  const singleImage__41 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_9feef7b1c5c76b6a49a564c273753f27.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__41 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const basicConfig__42 = {
    pushType: "",
    taskIds: "60",
    modalMessage: "开启后，可收到通知信息",
    isNeedLogin: true,
    startTime: null,
    endTime: null,
    unReserveImg: "https://sss.qingting.fm/qt-builder-manage/upload_e0e1c522922e40d62442647edd8f0409.png",
    reservedImg: "https://sss.qingting.fm/qt-builder-manage/upload_fef309f1245b40ba552027e8efb429cb.png",
    isStaging: false
  };
  const styleConfig = {
    unit: "rem",
    imgWidth: 1.6,
    imgHeight: "",
    top: 0.1,
    bottom: "",
    left: "",
    right: 0.4,
    display: "block",
    position: "absolute",
    zIndex: 0
  };
  const singleImage__43 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1296d812c0e139fb64f8f948d2a9b9e4.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__43 = {
    marginTop: 50,
    marginBottom: 10,
    marginLeft: null,
    marginRight: null
  };
  const layoutConfig = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__45 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_2f5bf82d86b0e26e3bbac0169883a755.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7ed5266mjx2g",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7ed5266mjx2g",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: true,
    openNewWebview: true
  };
  const imageContainerStyle__45 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const singleImage__46 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1b3916a98361e940b243744effee3139.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a6ea726obpmco",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a6ea726obpmco",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: true,
    openNewWebview: true
  };
  const imageContainerStyle__46 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const layoutConfig__47 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__48 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_3bf2b37bfda3415e9b99f68c24e8f3ab.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/17186e22c2db6vo85q8p",
    linkOutApp: "https://novel.qingting.fm/novels/17186e22c2db6vo85q8p",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: true,
    openNewWebview: true
  };
  const imageContainerStyle__48 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const singleImage__49 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_a5f3bea7271affa376719700c488d1b6.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: true,
    openNewWebview: true
  };
  const imageContainerStyle__49 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const baseLayoutConfig__50 = {
    commonStyle: {
      textAlign: "center",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: 10,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const textArchor__51 = {
    title: "查看更多电子书",
    link: "",
    linkInApp: "https://novel.qingting.fm",
    linkOutApp: "https://novel.qingting.fm",
    textStyle: {
      fontSize: 14,
      color: "#fbe0fb",
      fontWeight: 400,
      textDecoration: "underline",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    positionStyle: {
      position: "relative",
      top: 0,
      bottom: null,
      left: 0,
      right: null,
      type: "px"
    },
    openNewWebview: true
  };
  const timeController__52 = {
    startTime: null,
    endTime: "2020-04-20 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage__54 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_71ec1cbc6f62f555bb48c6c04e36765c.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__54 = {
    marginTop: 40,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const imageArchor__55 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_ea8a8c01279e9958bc811fc93d5ca33d.png",
    link: "",
    linkInApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    linkOutApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: 0,
      bottom: null,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const imageArchor__56 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_1845b531e7a3f9ae25534fc4e9ed9f11.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkOutApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: null,
      bottom: 1.6,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const imageArchor__57 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_8bcf086e56087e3c15f43d4e7f455847.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/76794",
    linkOutApp: "https://lkme.cc/qfD/PUKM0MatO",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: null,
      bottom: 1,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: false
  };
  const textArchor__58 = {
    title: "*购买增加抽奖机会,多买多得.最高抽iPhone11 Pro Max~",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    textStyle: {
      fontSize: 11,
      color: "#e0c18c",
      fontWeight: 400,
      textDecoration: "none",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    positionStyle: {
      position: "absolute",
      top: null,
      bottom: 0.2,
      left: 0.18,
      right: null,
      type: "rem"
    },
    openNewWebview: false
  };
  const textArchor__59 = {
    title: "直达抽奖",
    link: "4b7",
    linkInApp: "",
    linkOutApp: "",
    textStyle: {
      fontSize: 11,
      color: "#e0c18c",
      fontWeight: 400,
      textDecoration: "underline",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    },
    positionStyle: {
      position: "absolute",
      top: null,
      bottom: 0.2,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: false
  };
  const baseLayoutConfig__60 = {
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: "hidden",
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "absolute",
      type: "rem",
      top: 0,
      bottom: null,
      left: 0.16,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const basicConfig__61 = {
    endTime: "2020-04-21 23:59:59",
    title: "距结束：",
    isCustomizeEndTitle: false,
    customizeEndTitle: "活动结束啦",
    fontColor: "#ffffff",
    bgColor: "#7751d0",
    borderRadius: "10px 0",
    unit: "px",
    paddingTop: 5,
    paddingBottom: 5,
    paddingRight: 10,
    paddingLeft: 10,
    fontWeight: "",
    fontSize: 12,
    position: "static",
    top: "",
    bottom: "",
    left: "",
    right: "",
    display: "inline-block"
  };
  const baseLayoutConfig__62 = {
    commonStyle: {
      textAlign: "center",
      height: null,
      overflow: "hidden",
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "absolute",
      type: "rem",
      top: null,
      bottom: 2.5,
      left: 0,
      right: 0
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style__63 = {
    backgroundImage: `url(${btnStyle__63.bgImg})`,
    backgroundColor: btnStyle__63.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__63.color,
    fontSize: text__63.fontSize + unit,
    margin: '0 auto',
    width: btnStyle__63.width + unit,
    height: btnStyle__63.height + unit,
    lineHeight: btnStyle__63.height + unit,
    borderRadius: btnStyle__63.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__63 = {
    top: position__63.top + unit,
    left: position__63.left + unit,
    right: position__63.right + unit,
    bottom: position__63.bottom + unit
  };
  const reStyle__63 = {
    marginTop: position__63.top + unit,
    marginBottom: position__63.bottom + unit,
    marginLeft: position__63.left + unit,
    marginRight: position__63.right + unit
  };
  const envController__64 = {
    env: "all",
    operation: "allow",
    version: "8.6.2",
    comparison: "isGreaterOrEqual",
    versionEnv: "inIosApp",
    versionOperation: "deny"
  };
  const timeController__65 = {
    startTime: "2020-04-21 00:00:00",
    endTime: "2020-04-26 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage__67 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_0c25e31492b33fea968bfb2ba8015f7e.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__67 = {
    marginTop: 40,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const imageArchor__68 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_4e243e24ca771c22597ec79eb2451fc0.png",
    link: "",
    linkInApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    linkOutApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: 0,
      bottom: null,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const imageArchor__69 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_4efc391099f9d12e4e7f3fbf4c3504a7.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkOutApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    imageStyle: {
      width: 55,
      height: null
    },
    style: {
      position: "absolute",
      top: null,
      bottom: 1.4,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const baseLayoutConfig__70 = {
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "absolute",
      type: "rem",
      top: null,
      bottom: 2.15,
      left: 0,
      right: 0
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style__71 = {
    backgroundImage: `url(${btnStyle__71.bgImg})`,
    backgroundColor: btnStyle__71.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__71.color,
    fontSize: text__71.fontSize + unit,
    margin: '0 auto',
    width: btnStyle__71.width + unit,
    height: btnStyle__71.height + unit,
    lineHeight: btnStyle__71.height + unit,
    borderRadius: btnStyle__71.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__71 = {
    top: position__71.top + unit,
    left: position__71.left + unit,
    right: position__71.right + unit,
    bottom: position__71.bottom + unit
  };
  const reStyle__71 = {
    marginTop: position__71.top + unit,
    marginBottom: position__71.bottom + unit,
    marginLeft: position__71.left + unit,
    marginRight: position__71.right + unit
  };
  const timeController__72 = {
    startTime: "2020-04-27 00:00:00",
    endTime: "2020-04-30 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage__74 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_68d75a62f22ac7b08b76553e0b57f85a.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__74 = {
    marginTop: 40,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const imageArchor__75 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_0bb17368cffddfb1978c9855671fbac8.png",
    link: "",
    linkInApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    linkOutApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    imageStyle: {
      width: 50,
      height: null
    },
    style: {
      position: "absolute",
      top: 0,
      bottom: null,
      left: null,
      right: 0.18,
      type: "rem"
    },
    openNewWebview: true
  };
  const baseLayoutConfig__76 = {
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "absolute",
      type: "rem",
      top: 0.7,
      bottom: null,
      left: null,
      right: 0.3
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style__77 = {
    backgroundImage: `url(${btnStyle__77.bgImg})`,
    backgroundColor: btnStyle__77.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__77.color,
    fontSize: text__77.fontSize + unit__77,
    margin: '0 auto',
    width: btnStyle__77.width + unit__77,
    height: btnStyle__77.height + unit__77,
    lineHeight: btnStyle__77.height + unit__77,
    borderRadius: btnStyle__77.height / 2 + unit__77,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__77 = {
    top: position__77.top + unit__77,
    left: position__77.left + unit__77,
    right: position__77.right + unit__77,
    bottom: position__77.bottom + unit__77
  };
  const reStyle__77 = {
    marginTop: position__77.top + unit__77,
    marginBottom: position__77.bottom + unit__77,
    marginLeft: position__77.left + unit__77,
    marginRight: position__77.right + unit__77
  };
  const timeController__78 = {
    startTime: "2020-04-07 00:00:00",
    endTime: "2020-04-30 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage__79 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_8ceb42b70ec97b71f9fee58fc8f6f932.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__79 = {
    marginTop: 30,
    marginBottom: 10,
    marginLeft: null,
    marginRight: null
  };
  const config = {
    activity_id: 1004,
    canSetShare: false,
    shareAddChance: false,
    pageTitleCanModify: false,
    showTop: false,
    showBottom: false,
    serviceUrl: "",
    defaultStyle: {
      pageBg: "#700088",
      topImg: "",
      bottomImg: "",
      drawBackImg: "",
      prizeBorderColor: "",
      prizeNameColor: "",
      prizeDefaultColor: "",
      prizeSelectColor: "",
      drawBtnImg: "",
      ruleImg: "",
      myPrizeImg: ""
    },
    customeStyle: {
      prizeDefaultImg: "linear-gradient(0deg, rgb(255,246,217) 0%, rgb(255,255,255) 100%",
      prizeSelectImg: "",
      replaceCarousel: "抽奖时间：4.21-4.23"
    },
    locationStyle: {
      top: 0,
      bottom: 0,
      spacing: 24,
      type: "px"
    }
  };
  const singleImage__81 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_07c45ce71ba3d6a3b55911d5b60931fc.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__81 = {
    marginTop: 40,
    marginBottom: 10,
    marginLeft: null,
    marginRight: null
  };
  const tabNavs = [{
    title: "大咖精品",
    link: "",
    default: false,
    image: {
      inactive: "",
      active: ""
    }
  }, {
    title: "热门好书",
    link: "",
    default: false,
    image: {
      inactive: "",
      active: ""
    }
  }, {
    title: "儿童故事",
    link: "",
    default: false,
    image: {
      inactive: "",
      active: ""
    }
  }, {
    title: "重磅上新",
    link: "",
    default: false,
    image: {
      inactive: "",
      active: ""
    }
  }, {
    title: "全网首发",
    link: "",
    default: false,
    image: {
      inactive: "",
      active: ""
    }
  }];
  const tabNavsConfig = {
    fontSize: 14,
    color: "#ffffff",
    height: 44,
    itemHeight: 44,
    marginRight: 5,
    backgroundColor: "#5d0080",
    backgroundImage: "",
    showTitle: true,
    open: false,
    top: 0,
    active: {
      fontSize: 14,
      color: "#ffffff",
      fontWeight: 700,
      backgroundColor: "#700b96",
      backgroundImage: "",
      line: {
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderBottomColor: "transparent"
      }
    },
    inactive: {
      backgroundColor: "transparent",
      backgroundImage: ""
    },
    openCache: true,
    openLog: true
  };
  const singleImage__88 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_f901d88a87f7027c34d56917deee686c.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__88 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const singleImage__89 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_198aea106d69efd0b23921665ba3c696.png",
    link: "",
    linkInApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    linkOutApp: "http://sss.qingting.fm/super-vip-rights/build/index.html",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__89 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const timeController__90 = {
    startTime: "2020-04-16 23:59:59",
    endTime: "2020-04-26 23:59:59",
    dynamic: false,
    duration: 10
  };
  const singleImage__91 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_f40f3deb07166d650e8b01d06edfb310.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 95,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__91 = {
    marginTop: 30,
    marginBottom: 10,
    marginLeft: null,
    marginRight: null
  };
  const layoutConfig__92 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      }
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__93 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_5dfe1bf07453a91793f721e8e8c89ead.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/topic/423/index.html",
    linkOutApp: "https://sss.qingting.fm/topic/423/index.html",
    isCenter: true,
    widthType: "percent",
    width: 90,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__93 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const singleImage__94 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_c9a45e7a4604ada4fdcf301f18cc7d21.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/topic/423-ups/index.html",
    linkOutApp: "https://sss.qingting.fm/topic/423-ups/index.html",
    isCenter: true,
    widthType: "percent",
    width: 90,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__94 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  const envController__95 = {
    env: "all",
    operation: "allow",
    version: "8.6.2",
    comparison: "isGreaterOrEqual",
    versionEnv: "inIosApp",
    versionOperation: "deny"
  };
  const timeController__97 = {
    startTime: null,
    endTime: "2020-04-23 23:59:59",
    dynamic: false,
    duration: 10
  };
  const commonStyle = {
    backgroundImage: `url(${customStyle__98.bgImg})`,
    backgroundSize: 'cover',
    backgroundColor: customStyle__98.bgColor,
    backgroundRepeat: 'no-repeat',
    zIndex: customStyle__98.zIndex,
    aspectRatio: customStyle__98.aspectRatio
  };
  const style__98 = {
    top: {
      height: customStyle__98.height + unit
    },
    bottom: {
      height: customStyle__98.height + unit
    },
    left: {
      top: customStyle__98.top + unit,
      width: customStyle__98.width + unit,
      height: customStyle__98.height + unit
    },
    right: {
      top: customStyle__98.top + unit,
      width: customStyle__98.width + unit,
      height: customStyle__98.height + unit
    }
  };
  const style__99 = {
    backgroundImage: `url(${btnStyle__99.bgImg})`,
    backgroundColor: btnStyle__99.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__99.color,
    fontSize: text__99.fontSize + unit,
    margin: '0 auto',
    width: btnStyle__99.width + unit,
    height: btnStyle__99.height + unit,
    lineHeight: btnStyle__99.height + unit,
    borderRadius: btnStyle__99.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__99 = {
    top: position__99.top + unit,
    left: position__99.left + unit,
    right: position__99.right + unit,
    bottom: position__99.bottom + unit
  };
  const reStyle__99 = {
    marginTop: position__99.top + unit,
    marginBottom: position__99.bottom + unit,
    marginLeft: position__99.left + unit,
    marginRight: position__99.right + unit
  };
  const timeController__100 = {
    startTime: "2020-04-24 00:00:00",
    endTime: "2020-04-26 00:00:00",
    dynamic: false,
    duration: 10
  };
  const commonStyle__101 = {
    backgroundImage: `url(${customStyle__101.bgImg})`,
    backgroundSize: 'cover',
    backgroundColor: customStyle__101.bgColor,
    backgroundRepeat: 'no-repeat',
    zIndex: customStyle__101.zIndex,
    aspectRatio: customStyle__101.aspectRatio
  };
  const style__101 = {
    top: {
      height: customStyle__101.height + unit
    },
    bottom: {
      height: customStyle__101.height + unit
    },
    left: {
      top: customStyle__101.top + unit,
      width: customStyle__101.width + unit,
      height: customStyle__101.height + unit
    },
    right: {
      top: customStyle__101.top + unit,
      width: customStyle__101.width + unit,
      height: customStyle__101.height + unit
    }
  };
  const style__102 = {
    backgroundImage: `url(${btnStyle__102.bgImg})`,
    backgroundColor: btnStyle__102.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    color: text__102.color,
    fontSize: text__102.fontSize + unit,
    margin: '0 auto',
    width: btnStyle__102.width + unit,
    height: btnStyle__102.height + unit,
    lineHeight: btnStyle__102.height + unit,
    borderRadius: btnStyle__102.height / 2 + unit,
    textAlign: 'center',
    position: isAbsolute ? 'absolute' : 'relative',
    animation: hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__102 = {
    top: position__102.top + unit,
    left: position__102.left + unit,
    right: position__102.right + unit,
    bottom: position__102.bottom + unit
  };
  const reStyle__102 = {
    marginTop: position__102.top + unit,
    marginBottom: position__102.bottom + unit,
    marginLeft: position__102.left + unit,
    marginRight: position__102.right + unit
  };
  const imgInfo__103 = {
    img: ""
  };
  const basicConfig__103 = {
    unit: "px",
    display: "block",
    position: "fixed",
    width: 30,
    height: null,
    top: null,
    left: null,
    bottom: 90,
    right: 16,
    distance: 40,
    isNeedAnimation: true,
    zIndex: "7"
  };
  const singleImage__104 = {
    src: "https://sss.qingting.fm/qt-builder-manage/upload_41ffb1a3e9ce71bb17b79322f6617727.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__104 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null
  };
  return <ContainerRender id="e3a" nodeId="252c98d7-798d-4c3d-9605-477c481ffe3a" nodeType="component-container" containerProps={containerConfig}><RenderGif id="1e8" nodeId="024d4d8b-3123-4bd7-9b9a-f68d3a0361e8" nodeType="gif-animation" imgInfo={imgInfo}><ImageLink id="715" nodeId="5a1622f1-528f-4cbe-812c-62b6877e5715" nodeType="image-link" imageArchor={imageArchor} /><RenderRule id="a4c" nodeId="1cdb6625-881c-422f-bf8a-ecda03966a4c" nodeType="fixed-rule" basicConfig={basicConfig__3}></RenderRule><RenderShare id="7e0" nodeId="391f4235-00d5-4ee2-8868-e725ff6847e0" nodeType="fixed-share" basicConfig={basicConfig__4}></RenderShare><RenderVideo id="d26" nodeId="3ce29080-1e8d-4a0f-aa68-12384a4f5d26" nodeType="fixed-video" basicConfig={basicConfig__5} videoConfig={videoConfig}></RenderVideo></RenderGif><TimeController id="3e5" nodeId="f733ed17-b2ad-4604-a67c-160d5dd943e5" nodeType="time-controller" config={timeController}><MemberGroup id="a7a" nodeId="54ac75b6-396a-490f-a810-30a468d99a7a" nodeType="member-group"><SingleImage id="494" nodeId="f3115de0-4687-4b6c-baf7-126550c83494" nodeType="image" config={singleImage} containerStyle={imageContainerStyle}><ImageLink id="44a" nodeId="d80dfd49-1a7e-43d0-8caf-277b09a1944a" nodeType="image-link" imageArchor={imageArchor__9} /><ImageLink id="c12" nodeId="a0f63628-1863-4580-98dc-421f688acc12" nodeType="image-link" imageArchor={imageArchor__10} /><ImageLink id="be8" nodeId="6742b90d-f9ed-4f0b-b4ab-b4428fceebe8" nodeType="image-link" imageArchor={imageArchor__11} /><TextLink id="fdf" nodeId="d6691e39-269f-46d1-b37d-ef7ddba41fdf" nodeType="text-link" textArchor={textArchor} /><TextLink__13 id="428" nodeId="ab77bc8a-028f-41d2-ab61-3677e938e428" nodeType="text-link" textArchor={textArchor__13} /><BaseLayout id="bb1" nodeId="c9095726-7521-43e4-8b15-55880d4c1bb1" nodeType="base-layout" config={baseLayoutConfig}><BuyButton id="2ce" nodeId="4cc92d07-1727-4799-9502-6fc9970ce2ce" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style, abStyle) : Object.assign(style, reStyle)} text={text.content} popLog={popLog}></BuyButton></BaseLayout></SingleImage></MemberGroup></TimeController><EnvController id="706" nodeId="65012811-9bc5-46d4-b8ca-3a7ca360f706" nodeType="env-controller" config={envController}><TimeController__17 id="a6e" nodeId="f1d6fd19-13f7-4bed-883b-0a8711e45a6e" nodeType="time-controller" config={timeController__17}><MemberGroup__18 id="c36" nodeId="318e51a9-5c69-43b6-9bfb-ec6afc5e9c36" nodeType="member-group"><SingleImage id="a06" nodeId="f46e6596-48b9-4983-b821-f041fc6fba06" nodeType="image" config={singleImage__19} containerStyle={imageContainerStyle__19}><ImageLink__20 id="3de" nodeId="941efeec-ceb4-45bc-9545-ec59a502e3de" nodeType="image-link" imageArchor={imageArchor__20} /><ImageLink__21 id="1fd" nodeId="cc1f472d-362c-4096-8bb8-4f78294101fd" nodeType="image-link" imageArchor={imageArchor__21} /><BaseLayout id="469" nodeId="f9844f47-1a2e-488a-be55-d0541f5ff469" nodeType="base-layout" config={baseLayoutConfig__22}><BuyButton__23 id="70e" nodeId="10c8cbd1-920b-477d-945b-2ee92966570e" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__23, abStyle__23) : Object.assign(style__23, reStyle__23)} text={text__23.content} popLog={popLog}></BuyButton__23></BaseLayout></SingleImage></MemberGroup__18></TimeController__17></EnvController><TimeController__24 id="c7e" nodeId="d8e08540-a210-4450-9d67-88644550cc7e" nodeType="time-controller" config={timeController__24}><MemberGroup__25 id="30e" nodeId="b62449a8-a60b-42a5-aaf2-5cfa62ca330e" nodeType="member-group"><SingleImage id="b9f" nodeId="ed6aced3-f73e-407f-a6c5-c3d2d89efb9f" nodeType="image" config={singleImage__26} containerStyle={imageContainerStyle__26}><ImageLink id="554" nodeId="fc67711d-a926-42ed-9f13-12915c5a6554" nodeType="image-link" imageArchor={imageArchor__27} /><BaseLayout id="648" nodeId="9d0a12e0-57e2-4029-bd49-c774c9080648" nodeType="base-layout" config={baseLayoutConfig__28}><BuyButton__29 id="dc3" nodeId="40989256-6635-425d-8bb4-b74d65b34dc3" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__29, abStyle__29) : Object.assign(style__29, reStyle__29)} text={text__29.content} popLog={popLog}></BuyButton__29></BaseLayout></SingleImage></MemberGroup__25></TimeController__24><BaseLayout__30 id="f50" nodeId="24ea6a64-2cac-4f26-99de-33952ae9cf50" nodeType="base-layout" config={baseLayoutConfig__30}><SingleImage id="e63" nodeId="c2f5b1e8-d115-422a-be40-ed733b5a2e63" nodeType="image" config={singleImage__31} containerStyle={imageContainerStyle__31}></SingleImage><SwiperContainer id="09d" nodeId="53d26f10-8bb1-4d5c-96a7-e62217aa909d" nodeType="swiper" type={swiperType} config={swiperConfig}><SingleImage id="da7" nodeId="7d3bec25-18e7-4a02-8869-6088b42f1da7" nodeType="image" config={singleImage__33} containerStyle={imageContainerStyle__33}></SingleImage><SingleImage id="463" nodeId="8fe56737-db7a-4f82-8a10-0f3d6f298463" nodeType="image" config={singleImage__34} containerStyle={imageContainerStyle__34}></SingleImage><SingleImage id="d7b" nodeId="af21eb3f-64f5-43bf-a632-bd105e374d7b" nodeType="image" config={singleImage__35} containerStyle={imageContainerStyle__35}></SingleImage></SwiperContainer></BaseLayout__30><TimeController__36 id="54e" nodeId="c2770293-d8ac-447e-8e8b-749e086cb54e" nodeType="time-controller" config={timeController__36}><SingleImage id="97e" nodeId="fc5444a0-4ee9-4dcf-9ffb-af10b0c4697e" nodeType="image" config={singleImage__37} containerStyle={imageContainerStyle__37}></SingleImage><SingleImage id="624" nodeId="e47d279b-0f12-42bc-bed9-13f1d7fcb624" nodeType="image" config={singleImage__38} containerStyle={imageContainerStyle__38}></SingleImage></TimeController__36><TimeController__39 id="f14" nodeId="9786106a-ee17-48fc-bd09-5dcee10ebf14" nodeType="time-controller" config={timeController__39}><SingleImage id="e12" nodeId="8195fb7f-8a10-4a45-b824-a179a4a05e12" nodeType="image" config={singleImage__40} containerStyle={imageContainerStyle__40}></SingleImage><SingleImage id="9bc" nodeId="39697c64-0e87-428f-8f7b-b73db33079bc" nodeType="image" config={singleImage__41} containerStyle={imageContainerStyle__41}><RenderReserve id="345" nodeId="669ac66f-c606-4a17-8314-d07b44b58345" nodeType="reserve" styleConfig={styleConfig} basicConfig={basicConfig__42}></RenderReserve></SingleImage></TimeController__39><SingleImage id="b99" nodeId="65711ed0-7c13-4805-b5de-ec18b03ceb99" nodeType="image" config={singleImage__43} containerStyle={imageContainerStyle__43}></SingleImage><HorizontalLayout id="fb1" nodeId="cc885741-7796-4aab-b293-252cc9911fb1" nodeType="horizontal-layout" config={layoutConfig}><SingleImage id="054" nodeId="9a14232e-35cf-4810-a380-cebce907d054" nodeType="image" config={singleImage__45} containerStyle={imageContainerStyle__45}></SingleImage><SingleImage id="329" nodeId="69f0d857-de74-4e11-b098-2923e1a7c329" nodeType="image" config={singleImage__46} containerStyle={imageContainerStyle__46}></SingleImage></HorizontalLayout><HorizontalLayout__47 id="679" nodeId="d6259490-c090-461e-a8fa-cb0f2ca3d679" nodeType="horizontal-layout" config={layoutConfig__47}><SingleImage id="4e9" nodeId="37567bbf-b14c-48f7-b9a7-a9827112d4e9" nodeType="image" config={singleImage__48} containerStyle={imageContainerStyle__48}></SingleImage><SingleImage id="278" nodeId="fb82a468-9b0e-4f0f-a537-aad6ea556278" nodeType="image" config={singleImage__49} containerStyle={imageContainerStyle__49}></SingleImage></HorizontalLayout__47><BaseLayout id="545" nodeId="e3134e02-9d76-46b5-844a-2abfcedf2545" nodeType="base-layout" config={baseLayoutConfig__50}><TextLink id="225" nodeId="ec92fdb8-b69b-4869-8a23-150d6bbc8225" nodeType="text-link" textArchor={textArchor__51} /></BaseLayout><TimeController__52 id="671" nodeId="20867783-d1ae-4f85-9398-015c8f478671" nodeType="time-controller" config={timeController__52}><MemberGroup__53 id="9f8" nodeId="9ec93a84-56dc-4e8b-949a-a938cae829f8" nodeType="member-group"><SingleImage id="fa4" nodeId="30c5e065-558d-4177-acc0-e844e86c0fa4" nodeType="image" config={singleImage__54} containerStyle={imageContainerStyle__54}><ImageLink id="135" nodeId="8fad4679-0e06-4b9a-a0ad-4c10c0c15135" nodeType="image-link" imageArchor={imageArchor__55} /><ImageLink id="6f7" nodeId="0974d667-6a9b-4d6b-9b97-eac60d53b6f7" nodeType="image-link" imageArchor={imageArchor__56} /><ImageLink id="512" nodeId="cc6b17cb-c56c-46a2-85b5-d6255e1a1512" nodeType="image-link" imageArchor={imageArchor__57} /><TextLink id="8bb" nodeId="7c449491-e971-4d2b-a93c-d5c86fe2a8bb" nodeType="text-link" textArchor={textArchor__58} /><TextLink__59 id="b85" nodeId="95ec1c0c-e7d2-4da5-a751-6d474e58cb85" nodeType="text-link" textArchor={textArchor__59} /><BaseLayout id="541" nodeId="1fe06b98-0135-4747-a3a3-66369140f541" nodeType="base-layout" config={baseLayoutConfig__60}><RenderCountDown id="59f" nodeId="7eb23d43-4829-45b3-9a04-aae6d9e4759f" nodeType="countdown" basicConfig={basicConfig__61}></RenderCountDown></BaseLayout><BaseLayout id="b85" nodeId="5eb9cb95-5745-4b8f-9328-6610c13afb85" nodeType="base-layout" config={baseLayoutConfig__62}><BuyButton__63 id="400" nodeId="d897d099-361c-4d39-8f8d-cba5f3297400" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__63, abStyle__63) : Object.assign(style__63, reStyle__63)} text={text__63.content} popLog={popLog}></BuyButton__63></BaseLayout></SingleImage></MemberGroup__53></TimeController__52><EnvController__64 id="46d" nodeId="e4e68ac2-d0ef-4a76-aaf6-af575b76c46d" nodeType="env-controller" config={envController__64}><TimeController__65 id="abd" nodeId="b3d94ccf-e8e5-4743-89cc-ecb4f29b6abd" nodeType="time-controller" config={timeController__65}><MemberGroup__66 id="650" nodeId="92a2a85d-e88b-4813-bb85-0c4d007b6650" nodeType="member-group"><SingleImage id="850" nodeId="5ced6575-2934-4a58-90ba-0a57ae797850" nodeType="image" config={singleImage__67} containerStyle={imageContainerStyle__67}><ImageLink id="fae" nodeId="74ea5d81-6133-4040-9f18-7ca5afd06fae" nodeType="image-link" imageArchor={imageArchor__68} /><ImageLink id="ef6" nodeId="db5c511d-9420-4ad3-bbe8-a3c332a40ef6" nodeType="image-link" imageArchor={imageArchor__69} /><BaseLayout id="090" nodeId="a315d5a1-1c94-43a9-9dbd-7633d2856090" nodeType="base-layout" config={baseLayoutConfig__70}><BuyButton__71 id="c64" nodeId="b0a4a42c-b5d9-4953-82aa-e14a1c052c64" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__71, abStyle__71) : Object.assign(style__71, reStyle__71)} text={text__71.content} popLog={popLog}></BuyButton__71></BaseLayout></SingleImage></MemberGroup__66></TimeController__65></EnvController__64><TimeController__72 id="4b0" nodeId="fc5626a3-385f-4362-8c17-d86244e234b0" nodeType="time-controller" config={timeController__72}><MemberGroup__73 id="aac" nodeId="a0c9f6c1-a96b-479c-9c30-d1cb66b03aac" nodeType="member-group"><SingleImage id="593" nodeId="5fdb51f5-0788-42f0-b291-30db09620593" nodeType="image" config={singleImage__74} containerStyle={imageContainerStyle__74}><ImageLink id="85f" nodeId="03e28e2f-0344-493b-ae65-4e5e6159f85f" nodeType="image-link" imageArchor={imageArchor__75} /><BaseLayout id="ca1" nodeId="8628cd3c-35d4-4cd7-ad1b-516f97987ca1" nodeType="base-layout" config={baseLayoutConfig__76}><BuyButton__77 id="ae4" nodeId="b313d9b8-c59d-45e8-90ed-2c58e0f47ae4" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__77, abStyle__77) : Object.assign(style__77, reStyle__77)} text={text__77.content} popLog={popLog}></BuyButton__77></BaseLayout></SingleImage></MemberGroup__73></TimeController__72><TimeController__78 id="4b7" nodeId="2b0c4e36-6f92-4b6c-8f1a-08eca3a7a4b7" nodeType="time-controller" config={timeController__78}><SingleImage id="d6a" nodeId="47e920ac-6afe-42da-8a4f-946b4872ed6a" nodeType="image" config={singleImage__79} containerStyle={imageContainerStyle__79}></SingleImage><MemberDraw id="694" nodeId="74647349-7b0c-4e46-8abb-0b221320c694" nodeType="rotary-draw" {...config} threeParty={{
        jscookie,
        linkedme: window.linkedme,
        LotteryGrid,
        Toast,
        Modal,
        qtWebLog,
        qt,
        wxShare
      }}></MemberDraw></TimeController__78><SingleImage id="42e" nodeId="28d81049-4461-4db8-bb1f-1e75a0fd642e" nodeType="image" config={singleImage__81} containerStyle={imageContainerStyle__81}></SingleImage><TabNavsContainer id="f4d" nodeId="887676f2-9233-47d2-badf-bcf58570ef4d" nodeType="tab-navs" navs={tabNavs} config={tabNavsConfig}><ChannelList id="4f3" nodeId="a9a99e1f-a781-4b5a-9b68-49399ea444f3" nodeType="channelList" showType={showType} priceType={nowPriceType} showPurchaseBtn={showBuy} showOriPrice={showDynamicData.oriPrice} showPlayCount={showDynamicData.playCount} customStyle={customStyle}></ChannelList><ChannelList__84 id="b4d" nodeId="7ec5b957-2244-49fe-8b5c-644ea2678b4d" nodeType="channelList" showType={showType} priceType={nowPriceType} showPurchaseBtn={showBuy} showOriPrice={showDynamicData__84.oriPrice} showPlayCount={showDynamicData__84.playCount} customStyle={customStyle__84}></ChannelList__84><ChannelList__85 id="fb4" nodeId="d39bfa16-6d69-41bc-b5f7-f4d76f262fb4" nodeType="channelList" showType={showType} priceType={nowPriceType} showPurchaseBtn={showBuy} showOriPrice={showDynamicData__85.oriPrice} showPlayCount={showDynamicData__85.playCount} customStyle={customStyle__85}></ChannelList__85><ChannelList__86 id="f15" nodeId="e1f561db-1938-44cf-ad90-27ed4ceb5f15" nodeType="channelList" showType={showType} priceType={nowPriceType} showPurchaseBtn={showBuy} showOriPrice={showDynamicData__86.oriPrice} showPlayCount={showDynamicData__86.playCount} customStyle={customStyle__86}></ChannelList__86><ChannelList__87 id="c0d" nodeId="21f84182-aee5-4041-8083-96f945dd6c0d" nodeType="channelList" showType={showType} priceType={nowPriceType} showPurchaseBtn={showBuy} showOriPrice={showDynamicData__87.oriPrice} showPlayCount={showDynamicData__87.playCount} customStyle={customStyle__87}></ChannelList__87></TabNavsContainer><SingleImage id="cf0" nodeId="e5eda824-17ff-4a30-ad97-2ea0c0767cf0" nodeType="image" config={singleImage__88} containerStyle={imageContainerStyle__88}></SingleImage><SingleImage id="f3c" nodeId="f5225396-cacf-44ff-93cb-d58abeff8f3c" nodeType="image" config={singleImage__89} containerStyle={imageContainerStyle__89}></SingleImage><TimeController__90 id="a03" nodeId="dcb4dbdf-3c71-4b4d-935e-485dfe5dfa03" nodeType="time-controller" config={timeController__90}><SingleImage id="121" nodeId="e1f7f58f-a5bb-465f-9b01-e29181999121" nodeType="image" config={singleImage__91} containerStyle={imageContainerStyle__91}></SingleImage><HorizontalLayout id="e7b" nodeId="f633042a-5099-4255-8080-cb0058693e7b" nodeType="horizontal-layout" config={layoutConfig__92}><SingleImage id="aa3" nodeId="02fc9721-a9e8-46d4-8434-2e8101e54aa3" nodeType="image" config={singleImage__93} containerStyle={imageContainerStyle__93}></SingleImage><SingleImage id="eff" nodeId="7baef656-0e25-4bb5-b3ba-ef72bd1d5eff" nodeType="image" config={singleImage__94} containerStyle={imageContainerStyle__94}></SingleImage></HorizontalLayout></TimeController__90><EnvController__95 id="297" nodeId="fa5e16a7-4bff-43fe-9b67-3f7c63d36297" nodeType="env-controller" config={envController__95}><MemberGroup__96 id="466" nodeId="e1808a3b-66ce-407d-97f4-fa1a09bac466" nodeType="member-group"><TimeController__97 id="f65" nodeId="214038ec-b3ea-4e5d-a9f2-f14a14059f65" nodeType="time-controller" config={timeController__97}><FixedBar id="920" nodeId="c9782b66-1edd-48de-9628-4b53ac86c920" nodeType="fixed-bar" position={position__98} customStyle={Object.assign(commonStyle, style__98[position])} effects={effects} effectParam={effectParam}><BuyButton__99 id="72c" nodeId="80283895-87f8-453b-bb9d-b8df5863072c" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__99, abStyle__99) : Object.assign(style__99, reStyle__99)} text={text__99.content} popLog={popLog}></BuyButton__99></FixedBar></TimeController__97><TimeController__100 id="9fd" nodeId="29d5bc2d-83a0-4f22-9e43-26d94e43c9fd" nodeType="time-controller" config={timeController__100}><FixedBar__101 id="c9c" nodeId="66fc4706-f011-4b3d-8015-60a469286c9c" nodeType="fixed-bar" position={position__101} customStyle={Object.assign(commonStyle__101, style__101[position])} effects={effects} effectParam={effectParam__101}><BuyButton__102 id="e29" nodeId="fe3c5a81-7879-4229-a95c-dcefe7498e29" nodeType="buy-button" btnStyle={isAbsolute ? Object.assign(style__102, abStyle__102) : Object.assign(style__102, reStyle__102)} text={text__102.content} popLog={popLog}></BuyButton__102></FixedBar__101></TimeController__100></MemberGroup__96></EnvController__95><RenderButton id="e6c" nodeId="eb99ebd5-6f99-4bc7-8a11-5b3215a03e6c" nodeType="back-top" imgInfo={imgInfo__103} basicConfig={basicConfig__103}><SingleImage id="84a" nodeId="c1aff075-18a0-4c58-b881-5f910b83d84a" nodeType="image" config={singleImage__104} containerStyle={imageContainerStyle__104}></SingleImage></RenderButton></ContainerRender>;
});